var _defs, _rect, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _g77, _g78, _g79, _g80, _g81, _g82, _g83, _g84, _g85, _g86, _g87, _g88, _g89, _g90, _g91, _g92, _g93, _g94, _g95, _g96, _g97, _g98, _g99, _g100, _g101, _g102, _g103, _g104, _g105, _g106, _g107, _g108, _g109, _g110, _g111, _g112, _g113, _g114, _g115, _g116, _g117, _g118, _g119, _g120, _g121, _g122, _g123, _g124, _g125, _g126, _g127, _g128, _g129, _g130, _g131, _g132, _g133, _path, _path2, _g134, _path3, _g135, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 670.631,
    height: 560.684,
    viewBox: "0 0 670.631 560.684",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    width: 661.722,
    height: 478.691,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 208.964,
    height: 119.769,
    fill: "#f3dd92",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 69.132,
    height: 259.095,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5-2",
    "data-name": "Rectangle 5",
    width: 208.964,
    height: 119.769,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 402.208,
    height: 118.624,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M173.272,24.279,131.218,0,0,75.069H84.493Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M0,30.742H84.493l11.3-6.463L53.736,0Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M0,118.626H84.194L247.942,24.279,205.888,0Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 69.132,
    height: 287.395,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    width: 69.132,
    height: 206.533,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    width: 218.564,
    height: 126.702,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_280",
    "data-name": "Rectangle 280",
    width: 259.196,
    height: 159.871,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M912.179,496.854v96.27L998.3,542.893V446.623Z",
    transform: "translate(-912.179 -446.623)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M1268.175,497.334V594l-85.493-49.839V447.548Z",
    transform: "translate(-1182.682 -447.548)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M1183,653.2v97.7l86.122-50.231v-97.7Z",
    transform: "translate(-1183.004 -602.973)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M996.91,653.012v97.7L910.5,700.341V602.692Z",
    transform: "translate(-910.501 -602.692)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -2.343,
    y1: 1.808,
    x2: -2.34,
    y2: 1.808,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M937.682,712.406v-58.73l69.076,40.287v58.79Z",
    transform: "translate(-937.682 -653.677)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -2.455,
    y1: 2.339,
    x2: -2.452,
    y2: 2.339,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M1095.907,643.013v7.73h.01c0,.073-.01.146-.01.22,0,8.811,12.267,15.954,27.4,15.954s27.4-7.143,27.4-15.954c0-.074-.008-.146-.009-.22h.009v-7.73Z",
    transform: "translate(-1095.907 -643.013)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -6.338,
    y1: 11.5,
    x2: -6.333,
    y2: 11.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffbb96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.227,
    stopColor: "#fffbc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#f9b673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    stopColor: "#f9b876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.725,
    stopColor: "#fabe81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.805,
    stopColor: "#fcc892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "#fed2a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#ffc28c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc28c"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    width: 661.721,
    height: 478.691,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    width: 54.795,
    height: 17.661,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M1095.908,664.173v.22c0-.073.008-.146.01-.22Z",
    transform: "translate(-1095.908 -664.173)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -36494.621,
    y1: 1219.478,
    x2: -36461.309,
    y2: 1219.478,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M1123.306,678.668c-15.132,0-27.4-7.143-27.4-15.955V664.2h.01c0,.074-.01.146-.01.22,0,8.811,12.266,15.955,27.4,15.955s27.4-7.143,27.4-15.955c0-.074-.008-.146-.01-.22h.01v-1.487c0,8.811-12.267,15.955-27.4,15.955",
    transform: "translate(-1095.908 -662.713)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -6.338,
    y1: 15.212,
    x2: -6.333,
    y2: 15.212,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M1268.788,664.393v-.22h-.009c0,.074.009.147.009.22",
    transform: "translate(-1268.779 -664.173)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -44041.688,
    y1: 1219.373,
    x2: -44006.973,
    y2: 1219.373,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 52.396,
    height: 21.158,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M1095.907,608.971c0,8.812,12.267,15.955,27.4,15.955s27.4-7.143,27.4-15.955-12.266-15.954-27.4-15.954-27.4,7.143-27.4,15.954",
    transform: "translate(-1095.907 -593.017)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -5.617,
    y1: 4.978,
    x2: -5.612,
    y2: 4.978,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffba78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.035,
    stopColor: "#ffba78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#fec886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    width: 54.795,
    height: 16.509,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M1123.306,659.163c-14.81,0-26.844-6.847-27.35-15.4-.011.186-.048.368-.048.555,0,8.811,12.266,15.955,27.4,15.955s27.4-7.143,27.4-15.955c0-.187-.037-.369-.048-.555-.506,8.553-12.54,15.4-27.35,15.4",
    transform: "translate(-1095.908 -643.763)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.285,
    cy: 0.703,
    r: 2.086,
    gradientTransform: "matrix(0.301, 0, 0, -1, -4.429, 33.275)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M1117.734,617.653c0,6.587,9.169,11.927,20.48,11.927s20.481-5.339,20.481-11.927-9.169-11.926-20.481-11.926-20.48,5.34-20.48,11.926",
    transform: "translate(-1117.734 -605.727)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -7.683,
    y1: 6.491,
    x2: -7.676,
    y2: 6.491,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    "data-name": "Rectangle 35",
    width: 40.962,
    height: 12.566,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M1140.368,604.853c10.941,0,19.851,5,20.426,11.286.019-.213.055-.423.055-.64,0-6.587-9.169-11.926-20.481-11.926s-20.48,5.339-20.48,11.926c0,.217.036.427.055.64.575-6.287,9.485-11.286,20.425-11.286",
    transform: "translate(-1119.888 -603.573)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.719,
    cy: -0.036,
    r: 1.205,
    gradientTransform: "matrix(0.307, 0, 0, -1, -6.006, 45.743)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M1138.214,607.007c10.941,0,19.851,5,20.426,11.286.02-.213.055-.424.055-.64,0-6.587-9.17-11.926-20.481-11.926s-20.48,5.34-20.48,11.926c0,.216.036.427.055.64.575-6.287,9.485-11.286,20.425-11.286",
    transform: "translate(-1117.734 -605.727)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -9.417,
    y1: 7.896,
    x2: -9.408,
    y2: 7.896,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-37"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39",
    "data-name": "Rectangle 39",
    width: 21.833,
    height: 33.673,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M1112.557,642.375c5.488,1.489,7.918,10.137,5.427,19.314s-8.959,15.409-14.447,13.919-7.918-10.137-5.427-19.314,8.959-15.409,14.448-13.919",
    transform: "translate(-1097.131 -642.155)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 0.5,
    cy: 0.5,
    r: 0.514,
    gradientTransform: "matrix(0.807, 0, 0, -0.598, -1.57, 13.132)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f49587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.116,
    stopColor: "#bc7368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.236,
    stopColor: "#8b554d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#603a35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#3d2522"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609,
    stopColor: "#221513"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.735,
    stopColor: "#0f0908"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#030202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-39"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41",
    "data-name": "Rectangle 41",
    width: 22.612,
    height: 13.398,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M1199.343,592.33c6.156,2.1,10.306,6.266,9.268,9.315s-6.87,3.821-13.026,1.726-10.306-6.266-9.268-9.315,6.87-3.821,13.026-1.726",
    transform: "translate(-1186.158 -591.15)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 0.5,
    r: 0.208,
    gradientTransform: "matrix(1.256, 0, 0.001, -2.019, 4.312, 32.228)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-41"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43",
    "data-name": "Rectangle 43",
    width: 31.099,
    height: 17.955,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M1157.382,623.491l7.749,1.4c1.3.235,1.575,1.225.469,1.676l-6.6,2.69c-.439.179-.7.472-.687.783l.129,4.681c.021.783-1.523,1.236-2.613.765l-6.513-2.811a2.666,2.666,0,0,0-1.506-.14l-7.669,1.489c-1.284.249-2.515-.461-2.083-1.2l2.58-4.428a.646.646,0,0,0-.243-.87l-4.869-3.76c-.815-.629-.032-1.521,1.325-1.508l8.106.074a2.177,2.177,0,0,0,1.356-.4l4.66-3.813c.78-.638,2.5-.479,2.9.271l2.431,4.474a1.515,1.515,0,0,0,1.081.624",
    transform: "translate(-1135.189 -617.725)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -11.227,
    y1: 15.326,
    x2: -11.217,
    y2: 15.326,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-43"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M1150.968,615.362l-4.66,3.813a2.176,2.176,0,0,1-1.356.4l-8.107-.075c-1.357-.012-2.14.879-1.325,1.509l4.869,3.76a.645.645,0,0,1,.243.869l-2.58,4.428c-.432.741.8,1.452,2.083,1.2l7.67-1.49a2.668,2.668,0,0,1,1.506.14l6.512,2.811c1.091.471,2.635.019,2.613-.765l-.129-4.68c-.009-.311.249-.6.688-.783l6.6-2.691c1.106-.451.829-1.441-.469-1.675l-7.749-1.4a1.517,1.517,0,0,1-1.081-.624l-2.431-4.474a1.811,1.811,0,0,0-1.579-.668,2.13,2.13,0,0,0-1.323.4",
    transform: "translate(-1135.189 -614.964)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -9.882,
    y1: 8.416,
    x2: -9.873,
    y2: 8.416,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M1157.382,620.731l7.749,1.4c1.3.235,1.575,1.225.469,1.675L1159,626.5c-.439.179-.7.472-.687.783l.129,4.68c.021.784-1.523,1.236-2.613.765l-6.513-2.811a2.671,2.671,0,0,0-1.506-.14l-7.669,1.489c-1.284.249-2.515-.461-2.083-1.2l2.58-4.428a.646.646,0,0,0-.243-.87l-4.869-3.76c-.815-.63-.032-1.521,1.325-1.508l8.106.075a2.175,2.175,0,0,0,1.356-.4l4.66-3.813c.78-.638,2.5-.479,2.9.27l2.431,4.474a1.515,1.515,0,0,0,1.081.624",
    transform: "translate(-1135.189 -614.965)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 0.679,
    cy: 0.221,
    r: 0.687,
    gradientTransform: "matrix(0.577, 0, 0, -1, -4.745, 30.748)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-47"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M968,512.6c-16.2-9.35-16.277-24.463-.183-33.755s42.27-9.244,58.465.106,16.277,24.463.183,33.754c-8.014,4.627-18.529,6.938-29.064,6.938-10.624,0-21.269-2.349-29.4-7.044m-57.5-15.525,86.366,49.753,86.115-50.539-86.132-49.5Z",
    transform: "translate(-910.501 -446.79)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M1065.48,532.978c-10.011,5.78-13.755,13.811-11.263,21.307,1.5-4.491,5.251-8.775,11.263-12.246,16.094-9.292,42.269-9.245,58.465.105,6.122,3.534,9.932,7.893,11.446,12.448,2.517-7.533-1.3-15.651-11.446-21.509-8.13-4.694-18.778-7.043-29.4-7.044-10.537,0-21.049,2.311-29.064,6.938",
    transform: "translate(-1053.47 -526.04)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M1095.907,494.835v7.73h.01c0,.074-.01.147-.01.22,0,8.811,12.267,15.954,27.4,15.954s27.4-7.143,27.4-15.954c0-.074-.008-.147-.009-.22h.009v-7.73Z",
    transform: "translate(-1095.907 -494.835)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -6.338,
    y1: 13.465,
    x2: -6.333,
    y2: 13.465,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-52"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M1095.908,516v.22c0-.074.008-.146.01-.22Z",
    transform: "translate(-1095.908 -515.996)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -36494.621,
    y1: 1432.996,
    x2: -36461.309,
    y2: 1432.996,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-53"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M1123.306,530.491c-15.132,0-27.4-7.143-27.4-15.955v1.487h.01c0,.074-.01.146-.01.22,0,8.811,12.266,15.955,27.4,15.955s27.4-7.143,27.4-15.955c0-.073-.008-.146-.01-.22h.01v-1.487c0,8.811-12.267,15.955-27.4,15.955",
    transform: "translate(-1095.908 -514.536)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -6.338,
    y1: 17.871,
    x2: -6.333,
    y2: 17.871,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M1268.788,516.216V516h-.009c0,.074.009.146.009.22",
    transform: "translate(-1268.779 -515.996)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -44041.688,
    y1: 1432.872,
    x2: -44006.973,
    y2: 1432.872,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-55"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    width: 52.396,
    height: 21.156,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-56"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M1095.907,460.794c0,8.812,12.267,15.955,27.4,15.955s27.4-7.143,27.4-15.955-12.266-15.954-27.4-15.954-27.4,7.143-27.4,15.954",
    transform: "translate(-1095.907 -444.84)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -5.617,
    y1: 5.744,
    x2: -5.612,
    y2: 5.744,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-58"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63",
    "data-name": "Rectangle 63",
    width: 54.795,
    height: 16.508,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M1123.306,510.986c-14.81,0-26.844-6.847-27.35-15.4-.011.186-.048.368-.048.555,0,8.812,12.266,15.955,27.4,15.955s27.4-7.143,27.4-15.955c0-.187-.037-.369-.048-.555-.506,8.553-12.54,15.4-27.35,15.4",
    transform: "translate(-1095.908 -495.586)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 0.285,
    cy: 0.703,
    r: 2.086,
    gradientTransform: "matrix(0.301, 0, 0, -1, -4.429, 38.964)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M1117.734,469.476c0,6.587,9.169,11.927,20.48,11.927s20.481-5.34,20.481-11.927-9.169-11.926-20.481-11.926-20.48,5.34-20.48,11.926",
    transform: "translate(-1117.734 -457.55)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -7.683,
    y1: 7.515,
    x2: -7.676,
    y2: 7.515,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-63"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M1140.368,456.676c10.941,0,19.851,5,20.426,11.286.019-.213.055-.423.055-.64,0-6.587-9.169-11.926-20.481-11.926s-20.48,5.339-20.48,11.926c0,.217.036.427.055.64.575-6.287,9.485-11.286,20.425-11.286",
    transform: "translate(-1119.888 -455.396)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 0.719,
    cy: -0.036,
    r: 1.205,
    gradientTransform: "matrix(0.307, 0, 0, -1, -6.006, 53.217)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-65"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M1138.214,458.83c10.941,0,19.851,5,20.426,11.286.02-.213.055-.424.055-.64,0-6.587-9.17-11.926-20.481-11.926s-20.48,5.339-20.48,11.926c0,.216.036.427.055.64.575-6.287,9.485-11.286,20.425-11.286",
    transform: "translate(-1117.734 -457.55)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -9.417,
    y1: 9.135,
    x2: -9.408,
    y2: 9.135,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-66"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71",
    "data-name": "Rectangle 71",
    width: 21.833,
    height: 33.672,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-67"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M1117.829,476.876c5.488,1.49,7.918,10.137,5.427,19.314s-8.959,15.409-14.447,13.919-7.918-10.137-5.427-19.314,8.959-15.409,14.448-13.919",
    transform: "translate(-1102.403 -476.656)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 0.5,
    r: 0.514,
    gradientTransform: "matrix(0.807, 0, 0, -0.598, -1.578, 15.636)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-68"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_73",
    "data-name": "Rectangle 73",
    width: 22.612,
    height: 13.399,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-69"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M1199.343,444.153c6.156,2.1,10.306,6.266,9.268,9.315s-6.87,3.821-13.026,1.726-10.306-6.266-9.268-9.315,6.87-3.821,13.026-1.726",
    transform: "translate(-1186.158 -442.973)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: 0.5,
    r: 0.208,
    gradientTransform: "matrix(1.256, 0, 0.001, -2.019, 4.311, 37.295)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-70"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_75",
    "data-name": "Rectangle 75",
    width: 31.099,
    height: 17.954,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-71"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M1157.382,475.314l7.749,1.4c1.3.235,1.575,1.225.469,1.676l-6.6,2.69c-.439.179-.7.472-.687.783l.129,4.681c.021.783-1.523,1.236-2.613.765l-6.513-2.811a2.665,2.665,0,0,0-1.506-.14l-7.669,1.489c-1.284.249-2.515-.461-2.083-1.2l2.58-4.428a.646.646,0,0,0-.243-.87l-4.869-3.76c-.815-.629-.032-1.521,1.325-1.509l8.106.075a2.176,2.176,0,0,0,1.356-.4l4.66-3.813c.78-.638,2.5-.479,2.9.271l2.431,4.474a1.515,1.515,0,0,0,1.081.624",
    transform: "translate(-1135.189 -469.548)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -11.227,
    y1: 17.868,
    x2: -11.217,
    y2: 17.868,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-72"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M1150.968,467.185l-4.66,3.813a2.176,2.176,0,0,1-1.356.4l-8.107-.075c-1.357-.012-2.14.879-1.325,1.508l4.869,3.76a.645.645,0,0,1,.243.869l-2.58,4.428c-.432.741.8,1.452,2.083,1.2l7.67-1.489a2.669,2.669,0,0,1,1.506.141l6.512,2.811c1.091.471,2.635.018,2.613-.765l-.129-4.68c-.009-.311.249-.6.688-.783l6.6-2.691c1.106-.451.829-1.441-.469-1.676l-7.749-1.4a1.516,1.516,0,0,1-1.081-.624l-2.431-4.474a1.811,1.811,0,0,0-1.579-.668,2.131,2.131,0,0,0-1.323.4",
    transform: "translate(-1135.189 -466.788)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: -9.882,
    y1: 9.769,
    x2: -9.873,
    y2: 9.769,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-75"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M1157.382,472.554l7.749,1.4c1.3.235,1.575,1.225.469,1.676l-6.6,2.691c-.439.179-.7.471-.687.783l.129,4.68c.021.784-1.523,1.236-2.613.765l-6.513-2.811a2.671,2.671,0,0,0-1.506-.14l-7.669,1.49c-1.284.249-2.515-.461-2.083-1.2l2.58-4.428a.646.646,0,0,0-.243-.87l-4.869-3.76c-.815-.629-.032-1.521,1.325-1.508l8.106.074a2.176,2.176,0,0,0,1.356-.4l4.66-3.813c.78-.639,2.5-.478,2.9.27l2.431,4.474a1.515,1.515,0,0,0,1.081.624",
    transform: "translate(-1135.189 -466.788)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: 0.679,
    cy: 0.221,
    r: 0.687,
    gradientTransform: "matrix(0.577, 0, 0, -1, -4.745, 35.831)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-76"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_81",
    "data-name": "Rectangle 81",
    width: 126.106,
    height: 73.664,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-77"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M988.638,645.542l61.427,34.028-.062,37.2.062-37.2,64.68-36.464-64.68,36.464Z",
    transform: "translate(-988.638 -643.106)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-11",
    cx: 0.517,
    cy: 0.029,
    r: 0.67,
    gradientTransform: "matrix(0.584, 0, 0, -1, -1.033, 7.463)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-78"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_82",
    "data-name": "Rectangle 82",
    width: 252.943,
    height: 94.204,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-79"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M1219.721,997.8l4.794,2.76v-5.5l-4.794-2.76Z",
    transform: "translate(-1219.721 -992.3)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: -41.386,
    y1: 23.495,
    x2: -41.352,
    y2: 23.495,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.035,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.581,
    stopColor: "#d4d1d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eeebf2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-80"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M1234.809,944.444v5.5l45.875-26.259V918.2Z",
    transform: "translate(-1234.809 -918.2)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: -9.602,
    y1: 3.823,
    x2: -9.595,
    y2: 3.823,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-81"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M1219.721,935.7l4.782,2.76,45.874-26.244-4.756-2.775Z",
    transform: "translate(-1219.721 -909.444)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: -6.56,
    y1: 4.074,
    x2: -6.555,
    y2: 4.074,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-82"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M1234.983,724.569v57.654l62.433-36.415V688.155Z",
    transform: "translate(-1234.983 -688.155)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-83"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M1208.892,792.343l-5.83,43.312,54.619,31.991c38.291,22.108,100.18,22.219,138.233.25l38.6-23.556,22.349,13.577V805.193l-83.887-.091,13.823,11.555-36.839,22.47c-12.837,7.412-33.715,7.374-46.633-.084l-85.964-51.34Z",
    transform: "translate(-1203.062 -787.703)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-84"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M1217.039,699.966V774.71l5.687-3.317V703.232l62.434-36.414v65.3l5.686-3.317v-71.88Z",
    transform: "translate(-1217.039 -656.918)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -3.822,
    y1: 2.114,
    x2: -3.819,
    y2: 2.114,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-85"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M1702.5,829.838l16.625,9.721,8.562-4.609,1.718-5.029-27.02-13.516Z",
    transform: "translate(-1702.387 -816.405)",
    fill: "#fada70"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-86"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M1417.152,690.9v59.952l4.7,2.661V688.155Z",
    transform: "translate(-1417.152 -688.155)",
    fill: "#eedfaa"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-88"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_96",
    "data-name": "Rectangle 96",
    width: 81.172,
    height: 48.137,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-89"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_92",
    "data-name": "Rectangle 92",
    width: 49.221,
    height: 28.418,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-93"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_102",
    "data-name": "Rectangle 102",
    width: 96.86,
    height: 56.379,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-94"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_97",
    "data-name": "Rectangle 97",
    width: 48.932,
    height: 28.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-95"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_98",
    "data-name": "Rectangle 98",
    width: 48.929,
    height: 28.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-99"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_103",
    "data-name": "Rectangle 103",
    width: 2.012,
    height: 39.034,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-100"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_104",
    "data-name": "Rectangle 104",
    width: 19.031,
    height: 37.942,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-101"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_105",
    "data-name": "Rectangle 105",
    width: 35.181,
    height: 34.263,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-102"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_106",
    "data-name": "Rectangle 106",
    width: 19.44,
    height: 37.998,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-103"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_107",
    "data-name": "Rectangle 107",
    width: 35.542,
    height: 34.38,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-104"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M1434.511,931.464h0Zm-231.45-8.684v13.7l54.619,31.991c38.291,22.108,100.181,22.219,138.233.25l38.6-23.557V931.464l-38.6,23.556c-38.052,21.97-99.942,21.858-138.233-.249l-54.619-31.991Z",
    transform: "translate(-1203.061 -922.78)",
    fill: "#1dab4b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-106"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_110",
    "data-name": "Rectangle 110",
    width: 49.018,
    height: 29.102,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-107"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_111",
    "data-name": "Rectangle 111",
    width: 60.893,
    height: 36.022,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-108"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_112",
    "data-name": "Rectangle 112",
    width: 45.145,
    height: 26.973,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-109"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_113",
    "data-name": "Rectangle 113",
    width: 22.733,
    height: 13.958,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-110"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M1932.815,962.566l25.668,15.009-.074-13.788-25.594-14.867Z",
    transform: "translate(-1932.815 -948.92)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-111"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M1251.474,786.595l84.921,50.315c12.917,7.458,33.8,7.5,46.633.085l38.378-23.62.06.035-.06-6.294-38.378,23.62c-12.837,7.411-33.716,7.373-46.633-.085l-79.555-47.117Z",
    transform: "translate(-1251.474 -783.533)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-112"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M1726.629,826.068l10.006,6.445h78.048v-6.445Z",
    transform: "translate(-1726.629 -826.068)",
    fill: "#fada70"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-114"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_118",
    "data-name": "Rectangle 118",
    width: 35.714,
    height: 20.982,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-115"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_119",
    "data-name": "Rectangle 119",
    width: 24.577,
    height: 14.37,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-116"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_120",
    "data-name": "Rectangle 120",
    width: 18.543,
    height: 10.773,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-117"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M1208.828,810.14v23.127c10.983-2.079,18.922-8.088,18.922-15.176,0-.074-.008-.147-.01-.22h.01v-7.73Z",
    transform: "translate(-1208.828 -810.14)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: -20.247,
    y1: 9.597,
    x2: -20.23,
    y2: 9.597,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-118"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M1208.828,768.51v36.022l35.152-18.446-18.62-27.669Z",
    transform: "translate(-1208.828 -758.417)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-120"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M1095.633,831.3v.22c0-.073.007-.146.009-.22Z",
    transform: "translate(-1095.633 -831.301)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: -36784.531,
    y1: 978.556,
    x2: -36750.961,
    y2: 978.556,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-121"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M1123.031,845.8c-15.131,0-27.4-7.143-27.4-15.955v1.487h.009c0,.074-.009.146-.009.22,0,8.811,12.266,15.955,27.4,15.955s27.4-7.143,27.4-15.955c0-.074-.008-.146-.009-.22h.009v-1.487c0,8.811-12.266,15.955-27.4,15.955",
    transform: "translate(-1095.633 -829.841)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: -6.337,
    y1: 12.213,
    x2: -6.331,
    y2: 12.213,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-122"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M1268.513,831.521v-.22h-.009c0,.073.009.146.009.22",
    transform: "translate(-1268.504 -831.301)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: -43846.348,
    y1: 978.64,
    x2: -43811.781,
    y2: 978.64,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-123"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_127",
    "data-name": "Rectangle 127",
    width: 52.396,
    height: 21.157,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-124"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M1208.828,777.963v21.586c10.983-2.079,18.922-8.088,18.922-15.177,0-4.848-3.713-9.191-9.573-12.117Z",
    transform: "translate(-1208.828 -772.255)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: -11.506,
    y1: 7.247,
    x2: -11.496,
    y2: 7.247,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-127"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M1123.031,826.291c-14.81,0-26.844-6.847-27.349-15.4-.011.186-.048.368-.048.555,0,8.812,12.266,15.955,27.4,15.955s27.4-7.143,27.4-15.955c0-.187-.037-.369-.048-.555-.507,8.553-12.541,15.4-27.35,15.4",
    transform: "translate(-1095.633 -810.891)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-12",
    cx: 0.285,
    cy: 0.703,
    r: 2.086,
    gradientTransform: "matrix(0.301, 0, 0, -1, -4.428, 26.858)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-128"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M1208.828,784.257v17.269c7.081-1.877,12-6.034,12-10.86,0-3.7-2.9-7.009-7.439-9.2Z",
    transform: "translate(-1208.828 -781.47)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: -16.65,
    y1: 10.259,
    x2: -16.636,
    y2: 10.259,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-131"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M1140.094,771.981c10.94,0,19.85,5,20.425,11.286.019-.213.055-.424.055-.64,0-6.587-9.17-11.926-20.481-11.926s-20.481,5.339-20.481,11.926c0,.216.036.427.055.64.574-6.287,9.485-11.286,20.425-11.286",
    transform: "translate(-1119.613 -770.701)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-13",
    cx: 0.719,
    cy: -0.036,
    r: 1.205,
    gradientTransform: "matrix(0.307, 0, 0, -1, -6.005, 37.313)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-133"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M1137.939,774.135c10.94,0,19.85,5,20.425,11.286.02-.213.055-.424.055-.64,0-6.587-9.17-11.926-20.48-11.926s-20.481,5.339-20.481,11.926c0,.216.036.427.056.64.574-6.287,9.485-11.286,20.425-11.286",
    transform: "translate(-1117.458 -772.855)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: -9.414,
    y1: 6.499,
    x2: -9.406,
    y2: 6.499,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-135"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M1199.067,759.458c6.156,2.1,10.306,6.266,9.268,9.315s-6.87,3.821-13.026,1.726-10.305-6.266-9.267-9.315,6.87-3.821,13.026-1.726",
    transform: "translate(-1185.882 -758.279)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-14",
    cx: 0.5,
    r: 0.208,
    gradientTransform: "matrix(1.256, 0, 0.001, -2.019, 4.313, 26.513)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-137"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M1157.107,790.619l7.749,1.4c1.3.235,1.574,1.225.469,1.676l-6.6,2.691c-.439.179-.7.472-.688.783l.129,4.681c.022.783-1.522,1.236-2.613.765l-6.513-2.811a2.664,2.664,0,0,0-1.506-.14l-7.669,1.489c-1.284.249-2.515-.462-2.084-1.2l2.58-4.428a.645.645,0,0,0-.243-.87l-4.869-3.76c-.815-.629-.032-1.521,1.326-1.508l8.106.074a2.172,2.172,0,0,0,1.356-.4l4.66-3.813c.78-.638,2.5-.479,2.9.27l2.431,4.474a1.513,1.513,0,0,0,1.081.624",
    transform: "translate(-1134.914 -784.853)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: -11.225,
    y1: 12.46,
    x2: -11.215,
    y2: 12.46,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-138"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M1208.828,806.756a1.544,1.544,0,0,1,.382-.218l6.6-2.691c1.106-.451.829-1.44-.469-1.675l-6.517-1.18Z",
    transform: "translate(-1208.828 -800.991)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: -38.632,
    y1: 23.499,
    x2: -38.6,
    y2: 23.499,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-141"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M1157.107,787.859l7.749,1.4c1.3.235,1.574,1.225.469,1.675l-6.6,2.691c-.439.179-.7.472-.688.783l.129,4.68c.022.784-1.522,1.236-2.613.765l-6.513-2.811a2.666,2.666,0,0,0-1.506-.14l-7.669,1.49c-1.284.249-2.515-.462-2.084-1.2l2.58-4.428a.645.645,0,0,0-.243-.869l-4.869-3.76c-.815-.63-.032-1.521,1.326-1.508l8.106.074a2.174,2.174,0,0,0,1.356-.4l4.66-3.813c.78-.638,2.5-.479,2.9.27l2.431,4.474a1.513,1.513,0,0,0,1.081.624",
    transform: "translate(-1134.914 -782.092)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-15",
    cx: 0.679,
    cy: 0.221,
    r: 0.687,
    gradientTransform: "matrix(0.577, 0, 0, -1, -4.744, 25.014)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-143"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_144",
    "data-name": "Rectangle 144",
    width: 57.087,
    height: 70.151,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-144"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M1215.567,736.419l-2.733,38.57a47.41,47.41,0,0,0,51.274-69.157Z",
    transform: "translate(-1212.834 -705.832)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-16",
    cx: 0.149,
    cy: 0.357,
    r: 0.622,
    gradientTransform: "matrix(1.229, 0, 0, -1, 1.541, 7.27)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2af6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015,
    stopColor: "#28eef6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    stopColor: "#1fb7bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.252,
    stopColor: "#16868b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#0f5d60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494,
    stopColor: "#0a3b3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617,
    stopColor: "#052122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#020e0f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-145"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M1217.039,699.966V774.71l5.687-3.317V703.232l62.434-36.414v40.7l5.686-3.317V656.918Z",
    transform: "translate(-1217.039 -656.918)",
    fill: "#1dab4b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-146"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M1202.281,859.168l4.718,2.671V787.094l-4.718-2.624Z",
    transform: "translate(-1202.281 -784.47)",
    fill: "#eedfaa"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-147"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M1202.281,691.585l4.718,2.624,73.766-43.048-4.8-2.671Z",
    transform: "translate(-1202.281 -648.491)",
    fill: "#eedfaa"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-149"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149",
    "data-name": "Rectangle 149",
    width: 68.678,
    height: 98.057,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-150"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_164",
    "data-name": "Rectangle 164",
    width: 68.572,
    height: 97.166,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-151"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_166",
    "data-name": "Rectangle 166",
    width: 67.708,
    height: 46.753,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-152"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M938.9,776.427s4.519-21.375,16.382-14.526,10.168,13.649,20.9,19.846c11.863,6.849,7.909-13.584,29.939-.865V807.3l-67.708-36.435Z",
    transform: "translate(-938.415 -760.548)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: -3.688,
    y1: 3.061,
    x2: -3.684,
    y2: 3.061,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1dac4c"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-153"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M947.8,759.642c-6.637,2.959-9.275,15.111-9.384,15.627a.49.49,0,0,0,.958.2c.026-.122,2.639-12.177,8.825-14.935,2.083-.93,4.383-.684,6.833.731a31.4,31.4,0,0,1,10.9,10.279c2.3,3.192,4.676,6.493,10,9.566a9.484,9.484,0,0,0,4.682,1.514c2.369,0,3.967-1.453,5.624-2.959,3.392-3.082,7.236-6.577,19.633.58a.49.49,0,0,0,.49-.848c-13.018-7.517-17.324-3.6-20.783-.457-2.485,2.258-4.448,4.039-9.156,1.321-5.141-2.969-7.353-6.04-9.694-9.291a32.23,32.23,0,0,0-11.207-10.555A9.512,9.512,0,0,0,950.77,759a7.233,7.233,0,0,0-2.974.641",
    transform: "translate(-938.401 -759.001)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-155"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_172",
    "data-name": "Rectangle 172",
    width: 0.982,
    height: 34.359,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-156"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M1105.963,847.681l.058-12.5,0-.433.056-20.31a2.333,2.333,0,0,0-.145-.837.4.4,0,0,0-.343-.283.41.41,0,0,0-.358.3,2.17,2.17,0,0,0-.137.778l.055,20.373,0,.512.053,11.6Z",
    transform: "translate(-1105.095 -813.322)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: -238.453,
    y1: 6.428,
    x2: -238.238,
    y2: 6.428,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#82288f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311,
    stopColor: "#501858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.624,
    stopColor: "#250b28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864,
    stopColor: "#0a030b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-157"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_174",
    "data-name": "Rectangle 174",
    width: 0.479,
    height: 31.553,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-158"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M1106,847.932l.157-11.473.158-19.732c0-.192-.107-.348-.24-.348s-.241.156-.241.348l.082,19.732Z",
    transform: "translate(-1105.835 -816.379)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: -605.706,
    y1: 6.971,
    x2: -605.159,
    y2: 6.971,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dc3daa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    stopColor: "#a62e80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.764,
    stopColor: "#2f0d24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-159"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_183",
    "data-name": "Rectangle 183",
    width: 1.727,
    height: 20.448,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-161"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M1103.845,747.729l1.651,0,.04,7.65.039,12.195c0,.332-.371.6-.828.6s-.823-.269-.823-.6l-.039-12.2Z",
    transform: "translate(-1103.845 -747.729)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: -155.953,
    y1: 11.8,
    x2: -155.812,
    y2: 11.8,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#271273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    stopColor: "#1f0e5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#110834"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#080317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847,
    stopColor: "#020006"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-162"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_180",
    "data-name": "Rectangle 180",
    width: 1.081,
    height: 18.904,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-163"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M1105.192,750.919l-.063,6.876,0,.238-.062,11.174c0,.1.059.406.16.461a.483.483,0,0,0,.378.155.5.5,0,0,0,.392-.162c.094-.055.151-.334.151-.428l-.06-11.21,0-.281-.059-6.381Z",
    transform: "translate(-1105.065 -750.919)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: -260.006,
    y1: 12.724,
    x2: -259.771,
    y2: 12.724,
    xlinkHref: "#linear-gradient-36"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-164"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_182",
    "data-name": "Rectangle 182",
    width: 0.526,
    height: 17.36,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-165"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M1106.342,754.109l-.172,6.312L1106,771.278c0,.106.117.191.263.192s.264-.086.264-.192l-.09-10.856Z",
    transform: "translate(-1105.997 -754.109)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: -602.93,
    y1: 13.806,
    x2: -602.385,
    y2: 13.806,
    xlinkHref: "#linear-gradient-37"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-166"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M1099.73,802.812a4.292,4.292,0,0,0,1.948,3.359c1.075.621,1.947.123,1.947-1.111a4.292,4.292,0,0,0-1.947-3.359,1.775,1.775,0,0,0-.874-.267c-.637,0-1.074.5-1.074,1.378",
    transform: "translate(-1099.73 -801.434)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-168"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M1300.5,916.544v7.73h.009c0,.074-.009.146-.009.22,0,8.812,12.266,15.955,27.4,15.955s27.4-7.143,27.4-15.955c0-.074-.008-.146-.009-.22h.009v-7.73Z",
    transform: "translate(-1300.503 -916.544)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: -7.522,
    y1: 7.874,
    x2: -7.516,
    y2: 7.874,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-171"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M1300.5,937.7v.22c0-.074.007-.146.01-.22Z",
    transform: "translate(-1300.503 -937.704)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: -43662.789,
    y1: 825.247,
    x2: -43629.219,
    y2: 825.247,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-172"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M1327.9,952.2c-15.131,0-27.4-7.143-27.4-15.955v1.487h.01c0,.074-.01.146-.01.22,0,8.811,12.266,15.955,27.4,15.955s27.4-7.144,27.4-15.955c0-.073-.007-.146-.009-.22h.009v-1.487c0,8.811-12.266,15.955-27.4,15.955",
    transform: "translate(-1300.503 -936.244)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: -7.522,
    y1: 10.304,
    x2: -7.516,
    y2: 10.304,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-173"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M1473.383,937.924v-.22h-.009c0,.073.009.146.009.22",
    transform: "translate(-1473.374 -937.704)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: -51143.559,
    y1: 825.321,
    x2: -51108.848,
    y2: 825.321,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-175"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M1300.5,882.5c0,8.811,12.266,15.954,27.4,15.954s27.4-7.143,27.4-15.954-12.266-15.955-27.4-15.955-27.4,7.143-27.4,15.955",
    transform: "translate(-1300.503 -866.548)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: -6.675,
    y1: 3.566,
    x2: -6.67,
    y2: 3.566,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-178"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M1327.9,932.694c-14.81,0-26.844-6.847-27.349-15.4-.011.186-.048.368-.048.555,0,8.812,12.266,15.955,27.4,15.955s27.4-7.143,27.4-15.955c0-.187-.037-.369-.048-.555-.506,8.553-12.54,15.4-27.349,15.4",
    transform: "translate(-1300.503 -917.294)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-17",
    cx: 0.285,
    cy: 0.703,
    r: 2.086,
    gradientTransform: "matrix(0.301, 0, 0, -1, -5.255, 22.773)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-179"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M1322.329,891.185c0,6.587,9.169,11.926,20.481,11.926s20.48-5.34,20.48-11.926-9.17-11.927-20.48-11.927-20.481,5.34-20.481,11.927",
    transform: "translate(-1322.329 -879.258)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: -9.099,
    y1: 4.601,
    x2: -9.092,
    y2: 4.601,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-182"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M1344.964,878.384c10.94,0,19.851,5,20.425,11.286.019-.213.055-.423.055-.64,0-6.587-9.17-11.926-20.48-11.926s-20.481,5.339-20.481,11.926c0,.217.036.427.056.64.574-6.287,9.485-11.286,20.425-11.286",
    transform: "translate(-1324.483 -877.104)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-18",
    cx: 0.719,
    cy: -0.036,
    r: 1.205,
    gradientTransform: "matrix(0.307, 0, 0, -1, -7.104, 31.946)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-184"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M1342.809,880.538c10.941,0,19.851,5,20.425,11.286.019-.213.055-.424.055-.64,0-6.587-9.17-11.926-20.481-11.926s-20.481,5.34-20.481,11.926c0,.216.036.427.056.64.574-6.287,9.485-11.286,20.425-11.286",
    transform: "translate(-1322.328 -879.258)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: -11.133,
    y1: 5.61,
    x2: -11.124,
    y2: 5.61,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-185"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204",
    "data-name": "Rectangle 204",
    width: 21.829,
    height: 33.673,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-186"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M1317.152,915.906c5.488,1.49,7.918,10.137,5.427,19.314s-8.959,15.409-14.448,13.919-7.918-10.136-5.427-19.314,8.959-15.409,14.448-13.919",
    transform: "translate(-1301.726 -915.685)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-19",
    cx: 0.5,
    r: 0.514,
    gradientTransform: "matrix(0.807, 0, 0, -0.598, -1.871, 8.994)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-188"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M1403.937,865.86c6.156,2.1,10.306,6.266,9.268,9.315s-6.869,3.821-13.026,1.726-10.305-6.266-9.267-9.315,6.87-3.822,13.026-1.726",
    transform: "translate(-1390.752 -864.681)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-20",
    cx: 0.5,
    r: 0.208,
    gradientTransform: "matrix(1.256, 0, 0.001, -2.019, 5.06, 22.876)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-190"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M1361.977,897.022l7.749,1.4c1.3.235,1.574,1.225.469,1.676l-6.6,2.69c-.439.179-.7.472-.688.783l.129,4.681c.022.784-1.522,1.236-2.613.765l-6.513-2.811a2.663,2.663,0,0,0-1.506-.14l-7.67,1.489c-1.284.25-2.515-.461-2.083-1.2l2.58-4.428a.646.646,0,0,0-.243-.87l-4.869-3.76c-.815-.629-.032-1.521,1.325-1.509l8.106.074a2.174,2.174,0,0,0,1.356-.4l4.66-3.813c.78-.638,2.5-.478,2.9.271l2.431,4.474a1.516,1.516,0,0,0,1.081.624",
    transform: "translate(-1339.783 -891.256)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: -13.253,
    y1: 10.634,
    x2: -13.244,
    y2: 10.634,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-191"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M1355.563,888.893l-4.66,3.813a2.177,2.177,0,0,1-1.356.4l-8.107-.074c-1.357-.012-2.14.879-1.325,1.508l4.869,3.76a.646.646,0,0,1,.243.87l-2.58,4.428c-.432.742.8,1.452,2.083,1.2l7.67-1.49a2.663,2.663,0,0,1,1.506.141l6.513,2.811c1.09.471,2.634.019,2.613-.765l-.129-4.68c-.008-.311.249-.6.688-.783l6.6-2.691c1.106-.45.829-1.441-.468-1.676l-7.749-1.4a1.517,1.517,0,0,1-1.081-.624l-2.431-4.474a1.809,1.809,0,0,0-1.578-.668,2.132,2.132,0,0,0-1.323.4",
    transform: "translate(-1339.783 -888.496)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: -11.676,
    y1: 5.918,
    x2: -11.667,
    y2: 5.918,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-194"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M1361.977,894.262l7.749,1.4c1.3.235,1.574,1.225.469,1.676l-6.6,2.691c-.439.179-.7.471-.688.783l.129,4.68c.022.784-1.522,1.236-2.613.765l-6.513-2.811a2.668,2.668,0,0,0-1.506-.14l-7.67,1.49c-1.284.249-2.515-.462-2.083-1.2l2.58-4.428a.645.645,0,0,0-.243-.869l-4.869-3.76c-.815-.63-.032-1.521,1.325-1.509l8.106.075a2.176,2.176,0,0,0,1.356-.4l4.66-3.813c.78-.638,2.5-.479,2.9.27l2.431,4.474a1.516,1.516,0,0,0,1.081.624",
    transform: "translate(-1339.783 -888.496)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-21",
    cx: 0.679,
    cy: 0.221,
    r: 0.687,
    gradientTransform: "matrix(0.577, 0, 0, -1, -5.602, 21.364)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-195"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M1511.808,984.635v7.73h.01c0,.074-.01.146-.01.22,0,8.811,12.267,15.955,27.4,15.955s27.4-7.143,27.4-15.955c0-.074-.008-.146-.01-.22h.01v-7.73Z",
    transform: "translate(-1511.808 -984.635)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: -8.744,
    y1: 6.971,
    x2: -8.738,
    y2: 6.971,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-198"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    d: "M1511.809,1005.795v.22c0-.074.008-.146.01-.22Z",
    transform: "translate(-1511.809 -1005.795)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: -50549.957,
    y1: 727.214,
    x2: -50516.52,
    y2: 727.214,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-199"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    d: "M1539.207,1020.29c-15.132,0-27.4-7.143-27.4-15.955v1.487h.01c0,.074-.01.146-.01.22,0,8.811,12.266,15.954,27.4,15.954s27.4-7.143,27.4-15.954c0-.074-.007-.146-.009-.22h.009v-1.487c0,8.812-12.266,15.955-27.4,15.955",
    transform: "translate(-1511.809 -1004.335)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: -8.744,
    y1: 9.082,
    x2: -8.738,
    y2: 9.082,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-200"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    d: "M1684.689,1006.015v-.22h-.01c0,.074.01.146.01.22",
    transform: "translate(-1684.68 -1005.795)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: -58231.641,
    y1: 727.215,
    x2: -58197.082,
    y2: 727.215,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-201"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_219",
    "data-name": "Rectangle 219",
    width: 52.399,
    height: 21.158,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-202"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M1511.808,950.593c0,8.812,12.267,15.955,27.4,15.955s27.4-7.143,27.4-15.955-12.266-15.954-27.4-15.954-27.4,7.143-27.4,15.954",
    transform: "translate(-1511.808 -934.639)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: -7.769,
    y1: 3.214,
    x2: -7.763,
    y2: 3.214,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-205"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M1539.207,1000.785c-14.81,0-26.844-6.847-27.35-15.4-.011.186-.048.368-.048.555,0,8.812,12.266,15.955,27.4,15.955s27.4-7.143,27.4-15.955c0-.187-.036-.369-.047-.555-.506,8.553-12.54,15.4-27.35,15.4",
    transform: "translate(-1511.809 -985.385)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-22",
    cx: 0.285,
    cy: 0.703,
    r: 2.086,
    gradientTransform: "matrix(0.301, 0, 0, -1, -6.109, 20.159)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-206"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M1533.634,959.275c0,6.587,9.17,11.927,20.481,11.927s20.481-5.339,20.481-11.927-9.17-11.926-20.481-11.926-20.481,5.34-20.481,11.926",
    transform: "translate(-1533.634 -947.349)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: -10.561,
    y1: 4.131,
    x2: -10.554,
    y2: 4.131,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-209"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M1556.269,946.475c10.94,0,19.851,5,20.426,11.287.019-.213.055-.424.055-.64,0-6.587-9.169-11.926-20.481-11.926s-20.48,5.339-20.48,11.926c0,.216.036.427.055.64.575-6.288,9.485-11.287,20.425-11.287",
    transform: "translate(-1535.789 -945.195)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-23",
    cx: 0.719,
    cy: -0.036,
    r: 1.205,
    gradientTransform: "matrix(0.307, 0, 0, -1, -8.237, 28.511)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-211"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M1554.116,948.629c10.94,0,19.85,5,20.425,11.286.02-.213.056-.424.056-.64,0-6.587-9.17-11.926-20.481-11.926s-20.481,5.339-20.481,11.926c0,.217.036.427.055.64.574-6.287,9.485-11.286,20.425-11.286",
    transform: "translate(-1533.635 -947.349)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: -12.905,
    y1: 5.041,
    x2: -12.897,
    y2: 5.041,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-213"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M1528.458,984c5.489,1.49,7.918,10.137,5.427,19.314s-8.959,15.409-14.448,13.919-7.918-10.137-5.427-19.314,8.959-15.409,14.447-13.919",
    transform: "translate(-1513.032 -983.776)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-24",
    cx: 0.5,
    r: 0.514,
    gradientTransform: "matrix(0.807, 0, 0, -0.598, -2.182, 7.964)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-215"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M1615.244,933.951c6.156,2.1,10.306,6.266,9.268,9.315s-6.87,3.821-13.026,1.726-10.305-6.266-9.267-9.315,6.869-3.821,13.026-1.726",
    transform: "translate(-1602.059 -932.772)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-25",
    cx: 0.5,
    r: 0.208,
    gradientTransform: "matrix(1.256, 0, 0.001, -2.019, 5.83, 20.548)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-217"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M1573.283,965.113l7.749,1.4c1.3.235,1.574,1.225.469,1.676l-6.6,2.691c-.439.179-.7.472-.688.783l.129,4.681c.022.783-1.522,1.236-2.613.765l-6.512-2.811a2.666,2.666,0,0,0-1.506-.14l-7.67,1.489c-1.284.249-2.515-.462-2.083-1.2l2.579-4.428a.645.645,0,0,0-.243-.87l-4.87-3.76c-.815-.629-.032-1.521,1.326-1.508l8.106.074a2.174,2.174,0,0,0,1.356-.4l4.66-3.813c.78-.638,2.5-.479,2.9.271l2.431,4.474a1.515,1.515,0,0,0,1.081.624",
    transform: "translate(-1551.089 -959.347)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: -15.346,
    y1: 9.466,
    x2: -15.336,
    y2: 9.466,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-218"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M1566.869,956.984l-4.661,3.813a2.172,2.172,0,0,1-1.356.4l-8.106-.074c-1.358-.012-2.141.879-1.326,1.509l4.87,3.76a.646.646,0,0,1,.243.87l-2.579,4.428c-.432.741.8,1.452,2.083,1.2l7.67-1.49a2.667,2.667,0,0,1,1.506.141l6.512,2.811c1.09.471,2.634.019,2.613-.765l-.129-4.681c-.009-.311.249-.6.688-.783l6.6-2.691c1.106-.45.829-1.441-.469-1.675l-7.749-1.4a1.515,1.515,0,0,1-1.081-.624l-2.431-4.474a1.811,1.811,0,0,0-1.579-.668,2.132,2.132,0,0,0-1.323.4",
    transform: "translate(-1551.089 -956.587)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: -13.528,
    y1: 5.296,
    x2: -13.519,
    y2: 5.296,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-221"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M1573.283,962.353l7.749,1.4c1.3.235,1.574,1.225.469,1.675l-6.6,2.691c-.439.179-.7.472-.688.783l.129,4.68c.022.784-1.522,1.236-2.613.766l-6.512-2.811a2.664,2.664,0,0,0-1.506-.14l-7.67,1.489c-1.284.249-2.515-.461-2.083-1.2l2.579-4.428a.646.646,0,0,0-.243-.87l-4.87-3.76c-.815-.63-.032-1.521,1.326-1.509l8.106.074a2.172,2.172,0,0,0,1.356-.4l4.66-3.813c.78-.638,2.5-.479,2.9.27l2.431,4.474a1.515,1.515,0,0,0,1.081.624",
    transform: "translate(-1551.089 -956.587)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-26",
    cx: 0.679,
    cy: 0.221,
    r: 0.687,
    gradientTransform: "matrix(0.577, 0, 0, -1, -6.486, 19.027)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-222"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M1712.263,914.664v7.73h.009c0,.074-.009.146-.009.22,0,8.812,12.266,15.954,27.4,15.954s27.4-7.143,27.4-15.954c0-.074-.008-.147-.009-.22h.009v-7.73Z",
    transform: "translate(-1712.263 -914.664)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: -9.903,
    y1: 7.899,
    x2: -9.897,
    y2: 7.899,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-225"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M1712.263,935.825v.22c0-.074.008-.146.01-.22Z",
    transform: "translate(-1712.263 -935.825)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: -57019.746,
    y1: 827.949,
    x2: -56986.434,
    y2: 827.949,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-226"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M1739.66,950.319c-15.131,0-27.4-7.143-27.4-15.954v1.486h.01c0,.074-.01.147-.01.22,0,8.811,12.266,15.955,27.4,15.955s27.4-7.143,27.4-15.955c0-.074-.008-.147-.009-.22h.009v-1.486c0,8.811-12.266,15.954-27.4,15.954",
    transform: "translate(-1712.263 -934.365)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: -9.903,
    y1: 10.337,
    x2: -9.897,
    y2: 10.337,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-227"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M1885.143,936.045v-.22h-.009c0,.074.009.146.009.22",
    transform: "translate(-1885.134 -935.825)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: -65436.516,
    y1: 828.02,
    x2: -65401.805,
    y2: 828.02,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-229"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M1712.263,880.624c0,8.811,12.266,15.954,27.4,15.954s27.4-7.143,27.4-15.954-12.266-15.955-27.4-15.955-27.4,7.143-27.4,15.955",
    transform: "translate(-1712.263 -864.669)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: -8.806,
    y1: 3.575,
    x2: -8.801,
    y2: 3.575,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-232"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M1739.66,930.815c-14.81,0-26.844-6.847-27.35-15.4-.011.186-.048.368-.048.555,0,8.811,12.266,15.954,27.4,15.954s27.4-7.143,27.4-15.954c0-.187-.037-.369-.048-.555-.506,8.552-12.54,15.4-27.35,15.4",
    transform: "translate(-1712.263 -915.415)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-27",
    cx: 0.285,
    cy: 0.703,
    r: 2.086,
    gradientTransform: "matrix(0.301, 0, 0, -1, -6.919, 22.845)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-233"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M1734.089,889.305c0,6.587,9.169,11.926,20.48,11.926s20.481-5.339,20.481-11.926-9.17-11.927-20.481-11.927-20.48,5.339-20.48,11.927",
    transform: "translate(-1734.089 -877.379)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: -11.949,
    y1: 4.614,
    x2: -11.942,
    y2: 4.614,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-236"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M1756.724,876.5c10.94,0,19.85,5,20.425,11.287.019-.213.055-.424.055-.64,0-6.587-9.17-11.927-20.48-11.927s-20.481,5.34-20.481,11.927c0,.216.036.427.055.64.574-6.287,9.485-11.287,20.425-11.287",
    transform: "translate(-1736.243 -875.224)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-28",
    cx: 0.719,
    cy: -0.036,
    r: 1.205,
    gradientTransform: "matrix(0.307, 0, 0, -1, -9.312, 32.04)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-238"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M1754.569,878.659c10.941,0,19.851,5,20.425,11.286.019-.213.056-.423.056-.64,0-6.587-9.17-11.926-20.481-11.926s-20.481,5.339-20.481,11.926c0,.216.036.427.056.64.574-6.287,9.485-11.286,20.425-11.286",
    transform: "translate(-1734.088 -877.379)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: -14.586,
    y1: 5.626,
    x2: -14.578,
    y2: 5.626,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-240"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M1728.911,914.026c5.488,1.49,7.918,10.137,5.427,19.314s-8.959,15.409-14.448,13.919-7.918-10.137-5.427-19.314,8.959-15.409,14.447-13.919",
    transform: "translate(-1713.486 -913.806)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-29",
    cx: 0.5,
    r: 0.514,
    gradientTransform: "matrix(0.807, 0, 0, -0.598, -2.478, 9.023)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-242"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M1815.7,863.982c6.156,2.1,10.306,6.266,9.268,9.314s-6.87,3.821-13.026,1.726-10.305-6.266-9.268-9.315,6.869-3.821,13.026-1.725",
    transform: "translate(-1802.512 -862.802)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-30",
    cx: 0.5,
    r: 0.208,
    gradientTransform: "matrix(1.256, 0, 0.001, -2.019, 6.56, 22.942)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-244"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M1773.737,895.143l7.749,1.4c1.3.235,1.574,1.225.469,1.676l-6.6,2.691c-.439.179-.7.472-.688.783l.129,4.68c.022.784-1.522,1.236-2.613.765l-6.513-2.811a2.662,2.662,0,0,0-1.505-.14l-7.67,1.489c-1.284.249-2.515-.461-2.083-1.2l2.58-4.428a.645.645,0,0,0-.243-.87l-4.869-3.76c-.815-.629-.032-1.521,1.325-1.508l8.107.074a2.173,2.173,0,0,0,1.356-.4l4.66-3.813c.78-.638,2.5-.479,2.9.27l2.431,4.474a1.516,1.516,0,0,0,1.081.624",
    transform: "translate(-1751.544 -889.377)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: -17.331,
    y1: 10.667,
    x2: -17.321,
    y2: 10.667,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-245"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M1767.323,887.014l-4.66,3.813a2.175,2.175,0,0,1-1.356.4l-8.107-.075c-1.357-.012-2.14.879-1.325,1.509l4.869,3.76a.646.646,0,0,1,.243.87l-2.58,4.428c-.432.741.8,1.452,2.083,1.2l7.67-1.489a2.66,2.66,0,0,1,1.505.14l6.513,2.811c1.091.471,2.635.018,2.613-.765l-.129-4.68c-.008-.311.248-.6.688-.783l6.6-2.69c1.106-.45.828-1.441-.468-1.676l-7.749-1.4a1.515,1.515,0,0,1-1.081-.624l-2.431-4.474a1.811,1.811,0,0,0-1.578-.668,2.131,2.131,0,0,0-1.323.4",
    transform: "translate(-1751.544 -886.616)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: -15.286,
    y1: 5.935,
    x2: -15.277,
    y2: 5.935,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-246"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_336",
    "data-name": "Rectangle 336",
    width: 213.721,
    height: 241.266,
    fill: "rgba(0,0,0,0)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-248"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1076",
    "data-name": "Path 1076",
    d: "M146.446,106.9a5.777,5.777,0,1,0,5.778-5.776,5.779,5.779,0,0,0-5.778,5.776",
    transform: "translate(-146.446 -101.128)",
    fill: "rgba(0,0,0,0)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-249"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1077",
    "data-name": "Path 1077",
    d: "M30.437,122.654a3.071,3.071,0,1,0,3.071-3.07,3.071,3.071,0,0,0-3.071,3.07",
    transform: "translate(-30.437 -119.584)",
    fill: "#cf4343"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-250"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1079",
    "data-name": "Path 1079",
    d: "M23.8,65.472a1.638,1.638,0,1,0,1.638-1.638A1.638,1.638,0,0,0,23.8,65.472",
    transform: "translate(-23.802 -63.834)",
    fill: "rgba(0,0,0,0)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-31",
    cx: 0.607,
    cy: 0.339,
    r: 0.5,
    gradientTransform: "matrix(1, 0, 0, -1, 0.003, 101.497)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5ea5fc"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-252"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_311",
    "data-name": "Rectangle 311",
    width: 26.729,
    height: 26.729,
    fill: "rgba(0,0,0,0)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-253"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1084",
    "data-name": "Path 1084",
    d: "M169.877,37.02a13.364,13.364,0,1,1-13.364-13.364A13.364,13.364,0,0,1,169.877,37.02",
    transform: "translate(-143.148 -23.656)",
    fill: "rgba(0,0,0,0)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-32",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 15.974)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#93ffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    stopColor: "#90fafa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.048,
    stopColor: "#75cbcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#5ca1a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.149,
    stopColor: "#467a7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.207,
    stopColor: "#335959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#233d3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#162626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#0c1515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521,
    stopColor: "#050808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.657,
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-254"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_312",
    "data-name": "Rectangle 312",
    width: 196.576,
    height: 103.878,
    fill: "rgba(0,0,0,0)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-257"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1090",
    "data-name": "Path 1090",
    d: "M136.2,34.327a4.3,4.3,0,1,0,4.3-4.3,4.3,4.3,0,0,0-4.3,4.3",
    transform: "translate(-136.202 -30.028)",
    fill: "rgba(0,0,0,0)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-258"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1091",
    "data-name": "Path 1091",
    d: "M126.072,70.485c0,2.514.062,4.941.179,7.237h8.259c.115-2.3.177-4.723.177-7.237,0-14.041-1.928-25.425-4.307-25.425s-4.308,11.384-4.308,25.425",
    transform: "translate(-126.072 -45.06)",
    fill: "#fada70"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-259"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1092",
    "data-name": "Path 1092",
    d: "M124.572,48.127a6.265,6.265,0,1,0,6.265-6.265,6.266,6.266,0,0,0-6.265,6.265",
    transform: "translate(-124.572 -41.862)",
    fill: "#fada70"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-260"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1093",
    "data-name": "Path 1093",
    d: "M38.572,70.485c0,2.514.062,4.941.177,7.237h8.26c.115-2.3.177-4.723.177-7.237,0-14.041-1.928-25.425-4.307-25.425s-4.308,11.384-4.308,25.425",
    transform: "translate(-38.572 -45.06)",
    fill: "#fada70"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-261"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1094",
    "data-name": "Path 1094",
    d: "M37.072,48.127a6.266,6.266,0,1,0,6.265-6.265,6.266,6.266,0,0,0-6.265,6.265",
    transform: "translate(-37.072 -41.862)",
    fill: "#fada70"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-262"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_323",
    "data-name": "Rectangle 323",
    d: "M3.378,0h6.754A3.378,3.378,0,0,1,13.51,3.378V25.412a3.379,3.379,0,0,1-3.379,3.379H3.379A3.379,3.379,0,0,1,0,25.412V3.378A3.378,3.378,0,0,1,3.378,0Z",
    fill: "#fada70"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-263"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_325",
    "data-name": "Rectangle 325",
    d: "M2.658,0h8.194A2.658,2.658,0,0,1,13.51,2.658v12.51a2.659,2.659,0,0,1-2.659,2.659H2.659A2.659,2.659,0,0,1,0,15.168V2.658A2.658,2.658,0,0,1,2.658,0Z",
    fill: "#fada70"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-264"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_327",
    "data-name": "Rectangle 327",
    d: "M3.38,0h6.752a3.379,3.379,0,0,1,3.379,3.379V25.411a3.38,3.38,0,0,1-3.38,3.38H3.379A3.379,3.379,0,0,1,0,25.412V3.38A3.38,3.38,0,0,1,3.38,0Z",
    fill: "#fada70"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-265"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_329",
    "data-name": "Rectangle 329",
    d: "M2.659,0h8.194a2.658,2.658,0,0,1,2.658,2.658v12.51a2.659,2.659,0,0,1-2.659,2.659H2.659A2.659,2.659,0,0,1,0,15.168V2.659A2.659,2.659,0,0,1,2.659,0Z",
    fill: "#fada70"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-266"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1095",
    "data-name": "Path 1095",
    d: "M37.634,90.063c0,25.441,25.73,46.067,57.47,46.067s57.468-20.626,57.468-46.067S126.843,43.995,95.1,43.995s-57.47,20.624-57.47,46.068",
    transform: "translate(-37.634 -43.995)",
    fill: "rgba(0,0,0,0)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-267"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1096",
    "data-name": "Path 1096",
    d: "M46.678,86.794c0,19.669,20.975,35.615,46.846,35.615s46.843-15.945,46.843-35.615S119.395,51.179,93.524,51.179,46.678,67.124,46.678,86.794",
    transform: "translate(-46.678 -51.179)",
    fill: "rgba(0,0,0,0)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-268"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1097",
    "data-name": "Path 1097",
    d: "M48.764,85.838c0,18.181,19.876,32.92,44.395,32.92s44.394-14.739,44.394-32.92S117.677,52.916,93.159,52.916,48.764,67.655,48.764,85.838",
    transform: "translate(-48.764 -52.916)",
    fill: "rgba(0,0,0,0)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-270"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_334",
    "data-name": "Rectangle 334",
    width: 56.708,
    height: 51.233,
    fill: "rgba(0,0,0,0)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-271"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1100",
    "data-name": "Path 1100",
    d: "M88.386,52.917a59.014,59.014,0,0,0-11.872,1.2A43.8,43.8,0,0,0,125.6,103.773a27.079,27.079,0,0,0,7.176-17.937c0-18.181-19.876-32.92-44.394-32.92",
    transform: "translate(-76.072 -52.917)",
    fill: "rgba(0,0,0,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: -1.415,
    y1: 2.835,
    x2: -1.396,
    y2: 2.835,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient-31"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60811",
    "data-name": "Group 60811",
    transform: "translate(1131 -2543)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ROT",
    transform: "translate(-1324 1447)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_638",
    "data-name": "Group 638",
    transform: "translate(-211 -1357)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_282",
    "data-name": "Rectangle 282",
    width: 670.631,
    height: 560.684,
    transform: "translate(404 2453)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_637",
    "data-name": "Group 637",
    transform: "translate(404 2493.299)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_635",
    "data-name": "Group 635",
    transform: "translate(7.669 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(439.297 307.411)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M208.965,24.281,42.053,119.771,0,95.491,166.914,0Z",
    transform: "translate(-0.002 0.001)",
    fill: "#fada70"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(592.588 72.629)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M69.132,118.694,32.865,0,0,78.775l13.62,7.9V234.816L55.674,259.1V110.952Z",
    transform: "translate(0.003 -0.001)",
    fill: "#1dab4b"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(361.36 263.083)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M208.965,24.28,42.053,119.769,0,95.489,166.909,0Z",
    transform: "translate(-0.002 -0.001)",
    fill: "#f3dd92"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(0 360.067)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(151 43.553)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 164.217,
    height: 183.566,
    transform: "matrix(0.602, -0.799, 0.799, 0.602, -36.078, 47.893)",
    fill: "#f3dd92"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(306.419 87.881)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 82.19,
    height: 95.007,
    transform: "matrix(0.602, -0.799, 0.799, 0.602, -14.774, 19.613)",
    fill: "#f3dd92"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(0 -0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 243.932,
    height: 269.413,
    transform: "matrix(0.602, -0.799, 0.799, 0.602, -57.009, 75.68)",
    fill: "#f3dd92"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    transform: "translate(514.651 0.001)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M69.137,118.693,32.864,0,0,78.775l13.62,7.9V263.115L55.674,287.4V110.95Z",
    transform: "translate(-0.003 0.001)",
    fill: "#1dab4b"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(438.4 37.473)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M69.134,118.694,32.867,0,0,78.777l13.62,7.9v95.582l42.054,24.279V110.952Z",
    transform: "translate(0 -0.001)",
    fill: "#1dab4b"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    transform: "translate(275.509 219.694)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M218.566,24.28,176.513,0,127.508,27.678l-28.1-16.144L0,69.424,27.5,85.265,9.6,95.49,51.654,119.77,69.6,109.517,99.43,126.7l99.141-58.184L169.656,51.9Zm-119.149,99.3L5.375,69.411,99.42,14.646l93.787,53.9Z",
    transform: "translate(0 -0.001)",
    fill: "#f3dd92"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_633",
    "data-name": "Group 633",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_632",
    "data-name": "Group 632",
    transform: "translate(213.378 317.848)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_631",
    "data-name": "Group 631"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_630",
    "data-name": "Group 630",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17367",
    "data-name": "Path 17367",
    d: "M191.23,139.5Z",
    fill: "#58bc78"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_636",
    "data-name": "Group 636",
    transform: "translate(0 0.527)"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    transform: "translate(289.087 141.544)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    d: "M0,0H86.122V146.5H0Z",
    transform: "translate(0)",
    fill: "#1dac4c"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(374.814 141.837)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    d: "M0,0H85.493V146.452H0Z",
    transform: "translate(0)",
    fill: "#1dab4b"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(374.917 191.095)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    "data-name": "Path 276",
    d: "M0,0H124.937V166.421H0Z",
    transform: "translate(-40.651 12.172) rotate(-16.669)",
    fill: "#eedfaa"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    transform: "translate(288.555 191.006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    width: 116.695,
    height: 163.339,
    transform: "matrix(0.976, -0.219, 0.219, 0.976, -31.594, 7.082)",
    fill: "url(#linear-gradient)"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    transform: "translate(288.555 191.006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    width: 166.522,
    height: 125.048,
    transform: "translate(-40.475 135.975) rotate(-73.424)",
    fill: "#eedfaa"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41",
    transform: "translate(297.169 207.164)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    width: 112.264,
    height: 120.743,
    transform: "translate(-45.582 30.139) rotate(-33.473)",
    fill: "url(#linear-gradient-2)"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43",
    transform: "translate(347.314 203.784)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    width: 54.796,
    height: 23.905,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-3)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    "data-name": "Group 52",
    transform: "translate(347.315 210.027)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45",
    transform: "translate(-0.001 0.463)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    width: 0.01,
    height: 0.22,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-4)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    width: 54.795,
    height: 17.661,
    fill: "url(#linear-gradient-5)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49",
    transform: "translate(54.785 0.463)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    width: 0.009,
    height: 0.22,
    fill: "url(#linear-gradient-6)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55",
    transform: "translate(348.684 206.497)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    "data-name": "Group 54"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M1208.838,672c.261-.049.511-.111.768-.164V651.573h-.768Z",
    transform: "translate(-1174.418 -651.573)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M1219.7,671.183c.256-.072.516-.139.768-.216V651.573h-.768Z",
    transform: "translate(-1181.837 -651.573)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M1230.56,670.056c.265-.1.51-.222.768-.331V651.574h-.768Z",
    transform: "translate(-1189.256 -651.574)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M1197.978,672.491c.256-.027.515-.049.768-.08V651.573h-.768Z",
    transform: "translate(-1167 -651.573)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M1252.281,666.166c.262-.21.523-.418.768-.636V651.573h-.768Z",
    transform: "translate(-1204.093 -651.573)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M1263.141,662.453a11.91,11.91,0,0,0,.768-1.359v-9.52h-.768Z",
    transform: "translate(-1211.511 -651.574)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M1241.42,668.438c.256-.14.521-.273.768-.419V651.573h-.768Z",
    transform: "translate(-1196.674 -651.573)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M1187.118,672.72c.256-.008.514-.01.768-.022V651.573h-.768Z",
    transform: "translate(-1159.581 -651.573)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M1176.257,672.708c.255.01.512.017.768.022V651.573h-.768Z",
    transform: "translate(-1152.162 -651.573)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M1154.537,671.9c.257.051.507.111.768.157V651.573h-.768Z",
    transform: "translate(-1137.326 -651.573)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M1165.4,672.454c.252.029.513.043.768.068V651.574h-.768Z",
    transform: "translate(-1144.744 -651.574)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M1143.676,671.064q.38.111.768.215V651.574h-.768Z",
    transform: "translate(-1129.907 -651.574)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M1100.234,661.777A12.685,12.685,0,0,0,1101,663V651.574h-.768Z",
    transform: "translate(-1100.233 -651.574)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M1111.094,665.836c.243.205.51.4.768.6V651.574h-.768Z",
    transform: "translate(-1107.651 -651.574)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M1132.815,669.873c.254.1.509.2.768.3v-18.6h-.768Z",
    transform: "translate(-1122.488 -651.573)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M1121.955,668.213c.247.141.512.271.768.406V651.573h-.768Z",
    transform: "translate(-1115.07 -651.573)",
    fill: "#fdd65b"
  }))))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59",
    transform: "translate(347.314 187.939)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58",
    clipPath: "url(#clip-path-27)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    width: 61.258,
    height: 61.361,
    transform: "translate(-15.954 16.056) rotate(-45.182)",
    fill: "url(#linear-gradient-7)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_66",
    "data-name": "Group 66",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_65",
    "data-name": "Group 65",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    "data-name": "Group 64",
    transform: "translate(347.315 204.022)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62",
    clipPath: "url(#clip-path-29)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60",
    clipPath: "url(#clip-path-30)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 54.796,
    height: 16.509,
    transform: "translate(0 0)",
    fill: "url(#radial-gradient)"
  }))))))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_68",
    "data-name": "Group 68",
    transform: "translate(354.231 191.967)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67",
    "data-name": "Group 67",
    clipPath: "url(#clip-path-31)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33",
    "data-name": "Rectangle 33",
    width: 45.792,
    height: 45.869,
    transform: "translate(-11.926 12.002) rotate(-45.182)",
    fill: "url(#linear-gradient-8)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_95",
    "data-name": "Group 95",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_94",
    "data-name": "Group 94",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73",
    "data-name": "Group 73",
    transform: "translate(354.914 191.285)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_72",
    "data-name": "Group 72"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71",
    "data-name": "Group 71",
    clipPath: "url(#clip-path-33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_70",
    "data-name": "Group 70",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69",
    "data-name": "Group 69",
    clipPath: "url(#clip-path-34)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    width: 40.961,
    height: 12.566,
    transform: "translate(0)",
    fill: "url(#radial-gradient-2)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    "data-name": "Group 78",
    transform: "translate(354.23 191.967)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_77",
    "data-name": "Group 77"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_76",
    "data-name": "Group 76",
    clipPath: "url(#clip-path-33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_75",
    "data-name": "Group 75",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_74",
    "data-name": "Group 74",
    clipPath: "url(#clip-path-36)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36",
    "data-name": "Rectangle 36",
    width: 37.786,
    height: 37.913,
    transform: "matrix(0.705, -0.709, 0.709, 0.705, -6.283, 6.323)",
    fill: "url(#linear-gradient-9)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_83",
    "data-name": "Group 83",
    transform: "translate(347.701 203.512)",
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  }, _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_82",
    "data-name": "Group 82"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_81",
    "data-name": "Group 81",
    clipPath: "url(#clip-path-37)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_80",
    "data-name": "Group 80",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_79",
    "data-name": "Group 79",
    clipPath: "url(#clip-path-38)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    width: 41.462,
    height: 33.476,
    transform: "translate(-10.669 32.458) rotate(-74.812)",
    fill: "url(#radial-gradient-3)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_88",
    "data-name": "Group 88",
    transform: "translate(375.917 187.348)",
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  }, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_87",
    "data-name": "Group 87"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_86",
    "data-name": "Group 86",
    clipPath: "url(#clip-path-39)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85",
    "data-name": "Group 85",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84",
    "data-name": "Group 84",
    clipPath: "url(#clip-path-40)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    "data-name": "Rectangle 40",
    width: 22.274,
    height: 27.976,
    transform: "translate(-5.524 12.739) rotate(-71.215)",
    fill: "url(#radial-gradient-4)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93",
    transform: "translate(359.763 195.77)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_92",
    "data-name": "Group 92"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91",
    clipPath: "url(#clip-path-41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_90",
    "data-name": "Group 90",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89",
    clipPath: "url(#clip-path-42)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42",
    "data-name": "Rectangle 42",
    width: 32.001,
    height: 18.475,
    transform: "translate(-0.484 -0.241)",
    fill: "url(#linear-gradient-10)"
  }))))))))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_97",
    "data-name": "Group 97",
    transform: "translate(359.763 194.895)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_96",
    "data-name": "Group 96",
    clipPath: "url(#clip-path-43)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45",
    "data-name": "Rectangle 45",
    width: 36.148,
    height: 34.698,
    transform: "matrix(0.758, -0.652, 0.652, 0.758, -9.5, 7.763)",
    fill: "url(#linear-gradient-11)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_104",
    "data-name": "Group 104",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_103",
    "data-name": "Group 103",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_102",
    "data-name": "Group 102",
    transform: "translate(359.763 194.895)",
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  }, _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Group_101",
    "data-name": "Group 101"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_100",
    "data-name": "Group 100",
    clipPath: "url(#clip-path-41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_99",
    "data-name": "Group 99",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_98",
    "data-name": "Group 98",
    clipPath: "url(#clip-path-46)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_46",
    "data-name": "Rectangle 46",
    width: 32.001,
    height: 18.475,
    transform: "translate(-0.484 -0.241)",
    fill: "url(#radial-gradient-5)"
  }))))))))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Group_106",
    "data-name": "Group 106",
    transform: "translate(288.555 141.597)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_105",
    "data-name": "Group 105",
    clipPath: "url(#clip-path-47)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49",
    "data-name": "Rectangle 49",
    width: 168.724,
    height: 199.213,
    transform: "matrix(0.465, -0.886, 0.886, 0.465, -41.159, 78.44)",
    fill: "#fada70"
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Group_108",
    "data-name": "Group 108",
    transform: "translate(333.865 166.713)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_107",
    "data-name": "Group 107",
    clipPath: "url(#clip-path-48)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    width: 86.183,
    height: 28.553,
    transform: "translate(-1.745 0)",
    fill: "#1dab4b"
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Group_117",
    "data-name": "Group 117",
    transform: "translate(347.314 156.824)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116",
    "data-name": "Group 116",
    clipPath: "url(#clip-path-49)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54",
    "data-name": "Rectangle 54",
    width: 54.796,
    height: 23.905,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-12)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_131",
    "data-name": "Group 131",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_130",
    "data-name": "Group 130",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_126",
    "data-name": "Group 126",
    transform: "translate(347.315 163.067)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Group_125",
    "data-name": "Group 125"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_124",
    "data-name": "Group 124",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_119",
    "data-name": "Group 119",
    transform: "translate(-0.001 0.463)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_118",
    "data-name": "Group 118",
    clipPath: "url(#clip-path-52)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55",
    "data-name": "Rectangle 55",
    width: 0.01,
    height: 0.22,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_121",
    "data-name": "Group 121",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_120",
    "data-name": "Group 120",
    clipPath: "url(#clip-path-53)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56",
    "data-name": "Rectangle 56",
    width: 54.795,
    height: 17.661,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-14)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_123",
    "data-name": "Group 123",
    transform: "translate(54.785 0.463)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_122",
    "data-name": "Group 122",
    clipPath: "url(#clip-path-54)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 0.009,
    height: 0.22,
    fill: "url(#linear-gradient-15)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_129",
    "data-name": "Group 129",
    transform: "translate(348.684 159.538)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Group_128",
    "data-name": "Group 128"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_127",
    "data-name": "Group 127",
    clipPath: "url(#clip-path-55)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M1208.838,523.818c.261-.049.511-.111.768-.164V503.4h-.768Z",
    transform: "translate(-1174.418 -503.397)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M1219.7,523.006c.256-.072.516-.139.768-.216V503.4h-.768Z",
    transform: "translate(-1181.837 -503.397)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M1230.56,521.878c.265-.1.51-.222.768-.331V503.4h-.768Z",
    transform: "translate(-1189.256 -503.397)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M1197.978,524.314c.256-.027.515-.049.768-.08V503.4h-.768Z",
    transform: "translate(-1167 -503.397)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M1252.281,517.989c.262-.21.523-.418.768-.636V503.4h-.768Z",
    transform: "translate(-1204.093 -503.397)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M1263.141,514.276a11.91,11.91,0,0,0,.768-1.359V503.4h-.768Z",
    transform: "translate(-1211.511 -503.397)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M1241.42,520.261c.256-.14.521-.274.768-.419V503.4h-.768Z",
    transform: "translate(-1196.674 -503.397)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M1187.118,524.543c.256-.008.514-.01.768-.023V503.4h-.768Z",
    transform: "translate(-1159.581 -503.397)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M1176.257,524.531c.255.01.512.017.768.022V503.4h-.768Z",
    transform: "translate(-1152.162 -503.397)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M1154.537,523.728c.257.051.507.111.768.157V503.4h-.768Z",
    transform: "translate(-1137.326 -503.397)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M1165.4,524.278c.252.029.513.043.768.068V503.4h-.768Z",
    transform: "translate(-1144.744 -503.398)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M1143.676,522.886q.38.111.768.216V503.4h-.768Z",
    transform: "translate(-1129.907 -503.397)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M1100.234,513.6a12.686,12.686,0,0,0,.768,1.222V503.4h-.768Z",
    transform: "translate(-1100.233 -503.398)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M1111.094,517.659c.243.205.51.4.768.6V503.4h-.768Z",
    transform: "translate(-1107.651 -503.398)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M1132.815,521.7c.254.1.509.2.768.3V503.4h-.768Z",
    transform: "translate(-1122.488 -503.397)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M1121.955,520.036c.247.141.512.271.768.407V503.4h-.768Z",
    transform: "translate(-1115.07 -503.397)",
    fill: "#fdd65b"
  }))))))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Group_133",
    "data-name": "Group 133",
    transform: "translate(347.314 140.979)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_132",
    "data-name": "Group 132",
    clipPath: "url(#clip-path-56)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_61",
    "data-name": "Rectangle 61",
    width: 61.258,
    height: 61.36,
    transform: "translate(-15.954 16.056) rotate(-45.182)",
    fill: "url(#linear-gradient-16)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_140",
    "data-name": "Group 140",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_139",
    "data-name": "Group 139",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_138",
    "data-name": "Group 138",
    transform: "translate(347.315 157.063)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Group_137",
    "data-name": "Group 137"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_136",
    "data-name": "Group 136",
    clipPath: "url(#clip-path-58)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135",
    "data-name": "Group 135",
    transform: "translate(-0.001 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_134",
    "data-name": "Group 134",
    clipPath: "url(#clip-path-59)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_62",
    "data-name": "Rectangle 62",
    width: 54.796,
    height: 16.509,
    fill: "url(#radial-gradient-6)"
  }))))))))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Group_142",
    "data-name": "Group 142",
    transform: "translate(354.231 145.007)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_141",
    "data-name": "Group 141",
    clipPath: "url(#clip-path-60)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_65",
    "data-name": "Rectangle 65",
    width: 45.792,
    height: 45.869,
    transform: "matrix(0.705, -0.709, 0.709, 0.705, -11.926, 12.002)",
    fill: "url(#linear-gradient-17)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_169",
    "data-name": "Group 169",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_168",
    "data-name": "Group 168",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_147",
    "data-name": "Group 147",
    transform: "translate(354.914 144.326)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Group_146",
    "data-name": "Group 146"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_145",
    "data-name": "Group 145",
    clipPath: "url(#clip-path-33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_144",
    "data-name": "Group 144",
    transform: "translate(-0.001 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_143",
    "data-name": "Group 143",
    clipPath: "url(#clip-path-63)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_66",
    "data-name": "Rectangle 66",
    width: 40.961,
    height: 12.566,
    transform: "translate(0 0)",
    fill: "url(#radial-gradient-7)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_152",
    "data-name": "Group 152",
    transform: "translate(354.23 145.007)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "Group_151",
    "data-name": "Group 151"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_150",
    "data-name": "Group 150",
    clipPath: "url(#clip-path-33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_149",
    "data-name": "Group 149",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_148",
    "data-name": "Group 148",
    clipPath: "url(#clip-path-65)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_68",
    "data-name": "Rectangle 68",
    width: 37.786,
    height: 37.913,
    transform: "translate(-6.283 6.323) rotate(-45.182)",
    fill: "url(#linear-gradient-18)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_157",
    "data-name": "Group 157",
    transform: "translate(349.371 151.064)",
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  }, _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "Group_156",
    "data-name": "Group 156"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155",
    "data-name": "Group 155",
    clipPath: "url(#clip-path-66)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_154",
    "data-name": "Group 154",
    transform: "translate(0.001 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_153",
    "data-name": "Group 153",
    clipPath: "url(#clip-path-67)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70",
    "data-name": "Rectangle 70",
    width: 41.462,
    height: 33.476,
    transform: "translate(-10.669 32.458) rotate(-74.812)",
    fill: "url(#radial-gradient-8)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_162",
    "data-name": "Group 162",
    transform: "translate(375.917 140.387)",
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  }, _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "Group_161",
    "data-name": "Group 161"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160",
    "data-name": "Group 160",
    clipPath: "url(#clip-path-68)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_159",
    "data-name": "Group 159",
    transform: "translate(-0.001 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_158",
    "data-name": "Group 158",
    clipPath: "url(#clip-path-69)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_72",
    "data-name": "Rectangle 72",
    width: 22.274,
    height: 27.976,
    transform: "matrix(0.322, -0.947, 0.947, 0.322, -5.524, 12.739)",
    fill: "url(#radial-gradient-9)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_167",
    "data-name": "Group 167",
    transform: "translate(359.763 148.81)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "Group_166",
    "data-name": "Group 166"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_165",
    "data-name": "Group 165",
    clipPath: "url(#clip-path-70)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_164",
    "data-name": "Group 164",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_163",
    "data-name": "Group 163",
    clipPath: "url(#clip-path-71)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_74",
    "data-name": "Rectangle 74",
    width: 32.001,
    height: 18.475,
    transform: "translate(-0.484 -0.241)",
    fill: "url(#linear-gradient-19)"
  }))))))))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "Group_171",
    "data-name": "Group 171",
    transform: "translate(359.763 147.935)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170",
    "data-name": "Group 170",
    clipPath: "url(#clip-path-72)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_77",
    "data-name": "Rectangle 77",
    width: 36.148,
    height: 34.698,
    transform: "matrix(0.758, -0.652, 0.652, 0.758, -9.5, 7.763)",
    fill: "url(#linear-gradient-20)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_186",
    "data-name": "Group 186",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_185",
    "data-name": "Group 185",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_176",
    "data-name": "Group 176",
    transform: "translate(359.763 147.936)",
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  }, _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "Group_175",
    "data-name": "Group 175"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_174",
    "data-name": "Group 174",
    clipPath: "url(#clip-path-70)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_173",
    "data-name": "Group 173",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_172",
    "data-name": "Group 172",
    clipPath: "url(#clip-path-75)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_78",
    "data-name": "Rectangle 78",
    width: 32.001,
    height: 18.475,
    transform: "translate(-0.484 -0.241)",
    fill: "url(#radial-gradient-10)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_181",
    "data-name": "Group 181",
    transform: "translate(313.318 203.813)",
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  }, _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "Group_180",
    "data-name": "Group 180"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_179",
    "data-name": "Group 179",
    clipPath: "url(#clip-path-76)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_178",
    "data-name": "Group 178"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_177",
    "data-name": "Group 177",
    clipPath: "url(#clip-path-77)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_80",
    "data-name": "Rectangle 80",
    width: 126.107,
    height: 73.664,
    transform: "translate(0 0)",
    fill: "url(#radial-gradient-11)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_184",
    "data-name": "Group 184",
    transform: "translate(385.272 283.257)",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "Group_183",
    "data-name": "Group 183"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_182",
    "data-name": "Group 182",
    clipPath: "url(#clip-path-78)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M1215.684,915.981l2.245,13.47-.9,3.143,0,9.879,49.269,28.858c38.291,22.107,100.179,22.219,138.233.25l50.41-30.962,13.679,7.577-.307-42.049-98.274-.177,22.277,12.672L1358.579,939.4c-12.837,7.411-33.715,7.374-46.633-.084l-77.021-45.532-2.534,1.429Z",
    transform: "translate(-1215.683 -893.782)",
    fill: "#fada70"
  }))))))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "Group_188",
    "data-name": "Group 188",
    transform: "translate(386.553 314.48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_187",
    "data-name": "Group 187",
    clipPath: "url(#clip-path-79)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_84",
    "data-name": "Rectangle 84",
    width: 9.286,
    height: 6.962,
    transform: "matrix(0.287, -0.958, 0.958, 0.287, -2.269, 7.578)",
    fill: "url(#linear-gradient-21)"
  })))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "Group_190",
    "data-name": "Group 190",
    transform: "translate(391.334 290.996)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_189",
    "data-name": "Group 189",
    clipPath: "url(#clip-path-80)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_85",
    "data-name": "Rectangle 85",
    width: 41.007,
    height: 51.707,
    transform: "translate(-6.775 30.223) rotate(-77.365)",
    fill: "url(#linear-gradient-22)"
  })))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "Group_192",
    "data-name": "Group 192",
    transform: "translate(386.553 288.221)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_191",
    "data-name": "Group 191",
    clipPath: "url(#clip-path-81)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_86",
    "data-name": "Rectangle 86",
    width: 58.339,
    height: 49.233,
    transform: "matrix(0.886, -0.465, 0.465, 0.886, -11.939, 6.265)",
    fill: "url(#linear-gradient-23)"
  })))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "Group_194",
    "data-name": "Group 194",
    transform: "translate(391.39 218.09)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_193",
    "data-name": "Group 193",
    clipPath: "url(#clip-path-82)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_87",
    "data-name": "Rectangle 87",
    width: 112.105,
    height: 98.102,
    transform: "translate(-37.819 74.997) rotate(-63.239)",
    fill: "#fada70"
  })))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "Group_196",
    "data-name": "Group 196",
    transform: "translate(381.273 249.639)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_195",
    "data-name": "Group 195",
    clipPath: "url(#clip-path-83)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M0,0H257.114V110.7H0Z",
    transform: "matrix(0.999, -0.034, 0.034, 0.999, -3.459, 0.117)",
    fill: "#1dab4b"
  })))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "Group_198",
    "data-name": "Group 198",
    transform: "translate(385.703 208.191)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_197",
    "data-name": "Group 197",
    clipPath: "url(#clip-path-84)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_89",
    "data-name": "Rectangle 89",
    width: 97.785,
    height: 131.084,
    transform: "translate(-25.142 5.636) rotate(-12.635)",
    fill: "url(#linear-gradient-24)"
  })))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "Group_200",
    "data-name": "Group 200",
    transform: "translate(539.519 258.735)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_199",
    "data-name": "Group 199",
    clipPath: "url(#clip-path-85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M0,0H27.02V23.153H0Z",
    transform: "translate(0)",
    fill: "#fada70"
  })))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "Group_202",
    "data-name": "Group 202",
    transform: "translate(449.122 218.09)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_201",
    "data-name": "Group 201",
    clipPath: "url(#clip-path-86)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_91",
    "data-name": "Rectangle 91",
    width: 18.882,
    height: 64.8,
    transform: "translate(-13.949 3.127) rotate(-12.635)",
    fill: "#eedfaa"
  })))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "Group_254",
    "data-name": "Group 254",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_253",
    "data-name": "Group 253",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_217",
    "data-name": "Group 217",
    transform: "translate(526.162 282.505)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_216",
    "data-name": "Group 216"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_215",
    "data-name": "Group 215",
    clipPath: "url(#clip-path-88)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_205",
    "data-name": "Group 205",
    transform: "translate(31.952)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_204",
    "data-name": "Group 204"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_203",
    "data-name": "Group 203",
    clipPath: "url(#clip-path-89)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M1809.01,919.826l-47.952-27.685,1.269-.733,47.952,27.685Z",
    transform: "translate(-1761.058 -891.408)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_208",
    "data-name": "Group 208",
    transform: "translate(21.3 6.573)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_207",
    "data-name": "Group 207"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_206",
    "data-name": "Group 206",
    clipPath: "url(#clip-path-89)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M1775.4,940.567l-47.952-27.685,1.268-.732,47.953,27.685Z",
    transform: "translate(-1727.451 -912.149)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_211",
    "data-name": "Group 211",
    transform: "translate(10.652 13.145)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_210",
    "data-name": "Group 210"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_209",
    "data-name": "Group 209",
    clipPath: "url(#clip-path-89)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M1741.8,961.306l-47.952-27.685,1.268-.733,47.953,27.686Z",
    transform: "translate(-1693.848 -932.888)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_214",
    "data-name": "Group 214",
    transform: "translate(0 19.718)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_213",
    "data-name": "Group 213"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_212",
    "data-name": "Group 212",
    clipPath: "url(#clip-path-89)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M1708.194,982.046l-47.953-27.686,1.269-.733,47.953,27.686Z",
    transform: "translate(-1660.241 -953.628)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_236",
    "data-name": "Group 236",
    transform: "translate(386.879 274.83)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_235",
    "data-name": "Group 235"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_234",
    "data-name": "Group 234",
    clipPath: "url(#clip-path-93)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_221",
    "data-name": "Group 221",
    transform: "translate(47.928 28.129)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_220",
    "data-name": "Group 220"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_219",
    "data-name": "Group 219",
    clipPath: "url(#clip-path-94)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M1371.984,983.46l47.653-27.513,1.277.737L1373.262,984.2Z",
    transform: "translate(-1371.983 -955.948)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_224",
    "data-name": "Group 224",
    transform: "translate(35.948 21.097)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_223",
    "data-name": "Group 223"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_222",
    "data-name": "Group 222",
    clipPath: "url(#clip-path-95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M1334.176,961.271l47.653-27.513,1.277.737-47.653,27.513Z",
    transform: "translate(-1334.177 -933.759)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_227",
    "data-name": "Group 227",
    transform: "translate(23.965 14.065)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_226",
    "data-name": "Group 226"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_225",
    "data-name": "Group 225",
    clipPath: "url(#clip-path-95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M1296.366,939.082l47.653-27.513,1.277.737-47.653,27.513Z",
    transform: "translate(-1296.367 -911.569)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_230",
    "data-name": "Group 230",
    transform: "translate(11.983 7.032)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_229",
    "data-name": "Group 229"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_228",
    "data-name": "Group 228",
    clipPath: "url(#clip-path-95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M1258.557,916.892l47.653-27.513,1.277.737-47.653,27.513Z",
    transform: "translate(-1258.558 -889.38)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_233",
    "data-name": "Group 233",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_232",
    "data-name": "Group 232"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_231",
    "data-name": "Group 231",
    clipPath: "url(#clip-path-95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M1220.748,894.7,1268.4,867.19l1.277.737-47.653,27.513Z",
    transform: "translate(-1220.749 -867.19)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_240",
    "data-name": "Group 240",
    transform: "translate(504.852 308.021)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_239",
    "data-name": "Group 239"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_238",
    "data-name": "Group 238",
    clipPath: "url(#clip-path-99)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M1593.216,1010.951,1593,971.921l1.8,0,.212,39.031Z",
    transform: "translate(-1593.003 -971.921)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_243",
    "data-name": "Group 243",
    transform: "translate(478.801 307.556)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_242",
    "data-name": "Group 242"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_241",
    "data-name": "Group 241",
    clipPath: "url(#clip-path-100)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M1510.8,1008.122l17.292-37.669,1.74.272-17.292,37.669Z",
    transform: "translate(-1510.798 -970.453)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_246",
    "data-name": "Group 246",
    transform: "translate(454.725 305.529)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_245",
    "data-name": "Group 245"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_244",
    "data-name": "Group 244",
    clipPath: "url(#clip-path-101)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M1434.828,997.8l33.619-33.74,1.562.522-33.618,33.741Z",
    transform: "translate(-1434.829 -964.056)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_249",
    "data-name": "Group 249",
    transform: "translate(512.113 307.18)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_248",
    "data-name": "Group 248"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_247",
    "data-name": "Group 247",
    clipPath: "url(#clip-path-102)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M1633.615,1007.264l-17.7-37.733,1.737-.265,17.7,37.732Z",
    transform: "translate(-1615.913 -969.266)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_252",
    "data-name": "Group 252",
    transform: "translate(518.752 305.586)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_251",
    "data-name": "Group 251"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_250",
    "data-name": "Group 250",
    clipPath: "url(#clip-path-103)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M1670.847,998.617l-33.985-33.863,1.556-.517L1672.4,998.1Z",
    transform: "translate(-1636.861 -964.237)"
  }))))))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "Group_256",
    "data-name": "Group 256",
    transform: "translate(381.273 292.447)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_255",
    "data-name": "Group 255",
    clipPath: "url(#clip-path-104)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M0,0H231.45V67.905H0Z",
    transform: "translate(0 0)",
    fill: "#1dab4b"
  })))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "Group_270",
    "data-name": "Group 270",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_269",
    "data-name": "Group 269",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_259",
    "data-name": "Group 259",
    transform: "translate(562.813 272.03)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_258",
    "data-name": "Group 258"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_257",
    "data-name": "Group 257",
    clipPath: "url(#clip-path-106)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M1824.883,887.456l-49-28.37,1.269-.732,47.75,27.651Z",
    transform: "translate(-1775.889 -858.354)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_262",
    "data-name": "Group 262",
    transform: "translate(574.996 265.591)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_261",
    "data-name": "Group 261"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_260",
    "data-name": "Group 260",
    clipPath: "url(#clip-path-107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M1875.2,874.059l-60.871-35.29,1.269-.733,59.626,34.571Z",
    transform: "translate(-1814.326 -838.037)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_265",
    "data-name": "Group 265",
    transform: "translate(591.875 263.067)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_264",
    "data-name": "Group 264"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_263",
    "data-name": "Group 263",
    clipPath: "url(#clip-path-108)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M1912.71,857.048l-45.122-26.241,1.269-.733,43.877,25.522Z",
    transform: "translate(-1867.589 -830.075)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_268",
    "data-name": "Group 268",
    transform: "translate(614.287 264.249)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_267",
    "data-name": "Group 267"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_266",
    "data-name": "Group 266",
    clipPath: "url(#clip-path-109)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M1961.017,847.762l-22.71-13.226,1.269-.732,21.464,12.507Z",
    transform: "translate(-1938.308 -833.804)"
  }))))))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "Group_272",
    "data-name": "Group 272",
    transform: "translate(612.546 300.732)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_271",
    "data-name": "Group 271",
    clipPath: "url(#clip-path-110)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_115",
    "data-name": "Rectangle 115",
    width: 25.668,
    height: 28.655,
    fill: "#fada70"
  })))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "Group_274",
    "data-name": "Group 274",
    transform: "translate(396.616 248.317)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_273",
    "data-name": "Group 273",
    clipPath: "url(#clip-path-111)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_116",
    "data-name": "Rectangle 116",
    width: 169.992,
    height: 60.873,
    transform: "translate(0 0)",
    fill: "#1dab4b"
  })))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    id: "Group_276",
    "data-name": "Group 276",
    transform: "translate(547.202 261.798)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_275",
    "data-name": "Group 275",
    clipPath: "url(#clip-path-112)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_117",
    "data-name": "Rectangle 117",
    width: 34.334,
    height: 85.473,
    transform: "translate(-1.957 5.782) rotate(-71.301)",
    fill: "#fada70"
  })))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    id: "Group_287",
    "data-name": "Group 287",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_286",
    "data-name": "Group 286",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M1460,848.128l-.307-56.738-98.274-.178,22.277,12.673-33.741,20.755c-12.837,7.411-33.715,7.374-46.633-.084L1226.3,779.024l-2.534,1.429,79.555,47.117c12.918,7.458,33.8,7.5,46.633.084l38.379-23.62-17.862-9.88,86.327.138.239,49.128-22.889-13.067-38.239,23.088c-38.053,21.97-99.942,21.858-138.233-.249l-51.7-30.295-2.918,1.686h0l54.618,31.991c38.291,22.107,100.18,22.219,138.233.25l38.6-23.557Z",
    transform: "translate(-821.788 -532.135)",
    fill: "#fada70"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_279",
    "data-name": "Group 279",
    transform: "translate(388.378 267.521)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_278",
    "data-name": "Group 278"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_277",
    "data-name": "Group 277",
    clipPath: "url(#clip-path-114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M1225.481,864.373l34.436-20.245,1.277.737-34.436,20.245Z",
    transform: "translate(-1225.48 -844.128)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_282",
    "data-name": "Group 282",
    transform: "translate(388.378 260.792)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_281",
    "data-name": "Group 281"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_280",
    "data-name": "Group 280",
    clipPath: "url(#clip-path-115)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M1225.481,836.528l23.3-13.633,1.277.737-23.3,13.633Z",
    transform: "translate(-1225.48 -822.896)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_285",
    "data-name": "Group 285",
    transform: "translate(382.692 254.179)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_284",
    "data-name": "Group 284"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_283",
    "data-name": "Group 283",
    clipPath: "url(#clip-path-116)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M1207.544,812.066l17.266-10.036,1.277.737L1208.821,812.8Z",
    transform: "translate(-1207.543 -802.03)"
  }))))))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    id: "Group_289",
    "data-name": "Group 289",
    transform: "translate(383.101 256.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_288",
    "data-name": "Group 288",
    clipPath: "url(#clip-path-117)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_122",
    "data-name": "Rectangle 122",
    width: 18.922,
    height: 23.127,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-25)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_303",
    "data-name": "Group 303",
    transform: "translate(383.101 240.358)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_302",
    "data-name": "Group 302",
    clipPath: "url(#clip-path-118)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_298",
    "data-name": "Group 298",
    transform: "translate(-35.875 22.636)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    id: "Group_297",
    "data-name": "Group 297"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_296",
    "data-name": "Group 296",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_291",
    "data-name": "Group 291",
    transform: "translate(0.001 0.463)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_290",
    "data-name": "Group 290",
    clipPath: "url(#clip-path-120)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_123",
    "data-name": "Rectangle 123",
    width: 0.009,
    height: 0.22,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-26)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_293",
    "data-name": "Group 293",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_292",
    "data-name": "Group 292",
    clipPath: "url(#clip-path-121)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_124",
    "data-name": "Rectangle 124",
    width: 54.795,
    height: 17.661,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-27)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_295",
    "data-name": "Group 295",
    transform: "translate(54.787 0.463)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_294",
    "data-name": "Group 294",
    clipPath: "url(#clip-path-122)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_125",
    "data-name": "Rectangle 125",
    width: 0.009,
    height: 0.22,
    transform: "translate(0)",
    fill: "url(#linear-gradient-28)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_301",
    "data-name": "Group 301",
    transform: "translate(-34.502 19.105)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    id: "Group_300",
    "data-name": "Group 300"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_299",
    "data-name": "Group 299",
    clipPath: "url(#clip-path-123)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M1208.563,839.123c.261-.049.511-.111.768-.164V818.7h-.768Z",
    transform: "translate(-1174.144 -818.701)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M1219.424,838.311c.256-.072.516-.139.768-.216V818.7h-.768Z",
    transform: "translate(-1181.563 -818.701)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M1230.284,837.183c.265-.1.51-.222.768-.331V818.7h-.768Z",
    transform: "translate(-1188.982 -818.701)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M1197.7,839.619c.256-.027.515-.049.768-.08V818.7h-.768Z",
    transform: "translate(-1166.726 -818.701)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M1252.006,833.294c.262-.21.524-.418.768-.636V818.7h-.768Z",
    transform: "translate(-1203.82 -818.701)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M1262.866,829.581a11.978,11.978,0,0,0,.768-1.359V818.7h-.768Z",
    transform: "translate(-1211.238 -818.701)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M1241.145,835.566c.256-.14.521-.274.768-.419V818.7h-.768Z",
    transform: "translate(-1196.401 -818.701)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M1186.843,839.848c.256-.008.514-.011.768-.023V818.7h-.768Z",
    transform: "translate(-1159.308 -818.701)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M1175.982,839.836c.254.01.512.016.768.022V818.7h-.768Z",
    transform: "translate(-1151.889 -818.701)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M1154.261,839.033c.257.051.507.111.768.158V818.7h-.768Z",
    transform: "translate(-1137.052 -818.701)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M1165.122,839.581c.252.029.514.044.768.068V818.7h-.768Z",
    transform: "translate(-1144.471 -818.701)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M1143.4,838.191q.38.111.768.216V818.7h-.768Z",
    transform: "translate(-1129.633 -818.701)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M1099.959,828.9a12.678,12.678,0,0,0,.768,1.222V818.7h-.768Z",
    transform: "translate(-1099.959 -818.701)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M1110.819,832.963c.242.206.51.4.768.6V818.7h-.768Z",
    transform: "translate(-1107.377 -818.701)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M1132.54,837q.38.155.768.3V818.7h-.768Z",
    transform: "translate(-1122.215 -818.701)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M1121.68,835.341c.248.141.512.271.768.407V818.7h-.768Z",
    transform: "translate(-1114.796 -818.701)",
    fill: "#fdd65b"
  }))))))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    id: "Group_305",
    "data-name": "Group 305",
    transform: "translate(383.101 244.743)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_304",
    "data-name": "Group 304",
    clipPath: "url(#clip-path-124)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_128",
    "data-name": "Rectangle 128",
    width: 32.697,
    height: 32.66,
    transform: "translate(-13.646 13.733) rotate(-45.182)",
    fill: "url(#linear-gradient-29)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_312",
    "data-name": "Group 312",
    transform: "translate(383.101 240.358)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_311",
    "data-name": "Group 311",
    clipPath: "url(#clip-path-118)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_310",
    "data-name": "Group 310",
    transform: "translate(-35.875 16.63)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    id: "Group_309",
    "data-name": "Group 309"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_308",
    "data-name": "Group 308",
    clipPath: "url(#clip-path-29)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_307",
    "data-name": "Group 307",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_306",
    "data-name": "Group 306",
    clipPath: "url(#clip-path-127)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_129",
    "data-name": "Rectangle 129",
    width: 54.795,
    height: 16.509,
    transform: "translate(0 0)",
    fill: "url(#radial-gradient-12)"
  }))))))))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    id: "Group_314",
    "data-name": "Group 314",
    transform: "translate(383.101 247.664)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_313",
    "data-name": "Group 313",
    clipPath: "url(#clip-path-128)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_131",
    "data-name": "Rectangle 131",
    width: 22.689,
    height: 22.652,
    transform: "translate(-10.028 10.092) rotate(-45.182)",
    fill: "url(#linear-gradient-30)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_336",
    "data-name": "Group 336",
    transform: "translate(383.101 240.358)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_335",
    "data-name": "Group 335",
    clipPath: "url(#clip-path-118)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_319",
    "data-name": "Group 319",
    transform: "translate(-28.275 3.893)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    id: "Group_318",
    "data-name": "Group 318"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_317",
    "data-name": "Group 317",
    clipPath: "url(#clip-path-33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_316",
    "data-name": "Group 316",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_315",
    "data-name": "Group 315",
    clipPath: "url(#clip-path-131)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_132",
    "data-name": "Rectangle 132",
    width: 40.961,
    height: 12.566,
    fill: "url(#radial-gradient-13)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_324",
    "data-name": "Group 324",
    transform: "translate(-28.956 4.576)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    id: "Group_323",
    "data-name": "Group 323"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_322",
    "data-name": "Group 322",
    clipPath: "url(#clip-path-33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_321",
    "data-name": "Group 321",
    transform: "translate(-0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_320",
    "data-name": "Group 320",
    clipPath: "url(#clip-path-133)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_134",
    "data-name": "Rectangle 134",
    width: 37.786,
    height: 37.914,
    transform: "translate(-6.283 6.323) rotate(-45.182)",
    fill: "url(#linear-gradient-31)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_329",
    "data-name": "Group 329",
    transform: "translate(-7.273 -0.044)",
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  }, _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    id: "Group_328",
    "data-name": "Group 328"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_327",
    "data-name": "Group 327",
    clipPath: "url(#clip-path-68)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_326",
    "data-name": "Group 326",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_325",
    "data-name": "Group 325",
    clipPath: "url(#clip-path-135)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_136",
    "data-name": "Rectangle 136",
    width: 22.274,
    height: 27.976,
    transform: "translate(-5.523 12.739) rotate(-71.215)",
    fill: "url(#radial-gradient-14)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_334",
    "data-name": "Group 334",
    transform: "translate(-23.426 8.378)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    id: "Group_333",
    "data-name": "Group 333"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_332",
    "data-name": "Group 332",
    clipPath: "url(#clip-path-41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_331",
    "data-name": "Group 331",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_330",
    "data-name": "Group 330",
    clipPath: "url(#clip-path-137)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_138",
    "data-name": "Rectangle 138",
    width: 32.001,
    height: 18.475,
    transform: "translate(-0.484 -0.241)",
    fill: "url(#linear-gradient-32)"
  }))))))))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    id: "Group_338",
    "data-name": "Group 338",
    transform: "translate(383.101 253.85)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_337",
    "data-name": "Group 337",
    clipPath: "url(#clip-path-138)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140",
    "data-name": "Rectangle 140",
    width: 9.893,
    height: 9.648,
    transform: "matrix(0.758, -0.652, 0.652, 0.758, -2.85, 2.454)",
    fill: "url(#linear-gradient-33)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_345",
    "data-name": "Group 345",
    transform: "translate(383.101 240.358)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_344",
    "data-name": "Group 344",
    clipPath: "url(#clip-path-118)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_343",
    "data-name": "Group 343",
    transform: "translate(-23.426 7.503)",
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  }, _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    id: "Group_342",
    "data-name": "Group 342"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_341",
    "data-name": "Group 341",
    clipPath: "url(#clip-path-41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_340",
    "data-name": "Group 340",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_339",
    "data-name": "Group 339",
    clipPath: "url(#clip-path-141)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_141",
    "data-name": "Rectangle 141",
    width: 32.001,
    height: 18.475,
    transform: "translate(-0.484 -0.241)",
    fill: "url(#radial-gradient-15)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_352",
    "data-name": "Group 352",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_351",
    "data-name": "Group 351",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_350",
    "data-name": "Group 350",
    transform: "translate(384.369 223.692)",
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  }, _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    id: "Group_349",
    "data-name": "Group 349"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_348",
    "data-name": "Group 348",
    clipPath: "url(#clip-path-143)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_347",
    "data-name": "Group 347",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_346",
    "data-name": "Group 346",
    clipPath: "url(#clip-path-144)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_143",
    "data-name": "Rectangle 143",
    width: 57.086,
    height: 70.151,
    transform: "translate(0)",
    fill: "url(#radial-gradient-16)"
  }))))))))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    id: "Group_354",
    "data-name": "Group 354",
    transform: "translate(385.703 208.191)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_353",
    "data-name": "Group 353",
    clipPath: "url(#clip-path-145)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_146",
    "data-name": "Rectangle 146",
    width: 97.785,
    height: 131.084,
    transform: "translate(-25.142 5.636) rotate(-12.635)",
    fill: "url(#linear-gradient-24)"
  })))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    id: "Group_356",
    "data-name": "Group 356",
    transform: "translate(381.026 248.614)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_355",
    "data-name": "Group 355",
    clipPath: "url(#clip-path-146)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147",
    "data-name": "Rectangle 147",
    width: 75.47,
    height: 26.713,
    transform: "matrix(0.287, -0.958, 0.958, 0.287, -21.261, 71.002)",
    fill: "#eedfaa"
  })))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    id: "Group_358",
    "data-name": "Group 358",
    transform: "translate(381.026 205.52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_357",
    "data-name": "Group 357",
    clipPath: "url(#clip-path-147)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148",
    "data-name": "Rectangle 148",
    width: 87.729,
    height: 64.708,
    transform: "translate(-11.575 3.147) rotate(-15.21)",
    fill: "#eedfaa"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_371",
    "data-name": "Group 371",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_370",
    "data-name": "Group 370",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_361",
    "data-name": "Group 361",
    transform: "translate(297.423 207.834)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    id: "Group_360",
    "data-name": "Group 360"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_359",
    "data-name": "Mask Group 359",
    clipPath: "url(#clip-path-149)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M938.484,714.2l68.677,39.651V695.445l-68.677-39.651Z",
    transform: "translate(-938.484 -655.794)",
    fill: "#1dac4c"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_364",
    "data-name": "Group 364",
    transform: "translate(297.098 208.208)",
    opacity: 0.7,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    id: "Group_363",
    "data-name": "Group 363"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_362",
    "data-name": "Group 362",
    clipPath: "url(#clip-path-150)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M1006.03,754.138l-68.572-39.589V656.972l68.572,39.589ZM938.409,714l66.671,38.492v-55.38l-66.671-38.493Z",
    transform: "translate(-937.458 -656.972)",
    fill: "#fada70"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    "data-name": "Path 275",
    d: "M0,0H.951V56.179H0Z",
    transform: "translate(6.404 4.736)",
    fill: "#b09a62"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151",
    "data-name": "Rectangle 151",
    width: 0.951,
    height: 56.211,
    transform: "translate(14.127 9.169)",
    fill: "#b09a62"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_152",
    "data-name": "Rectangle 152",
    width: 0.951,
    height: 56.242,
    transform: "translate(21.851 13.602)",
    fill: "#b09a62"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_153",
    "data-name": "Rectangle 153",
    width: 0.951,
    height: 56.274,
    transform: "translate(29.574 18.035)",
    fill: "#b09a62"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_154",
    "data-name": "Rectangle 154",
    width: 0.951,
    height: 56.306,
    transform: "translate(37.297 22.469)",
    fill: "#b09a62"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_155",
    "data-name": "Rectangle 155",
    width: 0.951,
    height: 56.338,
    transform: "translate(45.021 26.902)",
    fill: "#b09a62"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_156",
    "data-name": "Rectangle 156",
    width: 0.951,
    height: 56.37,
    transform: "translate(52.744 31.335)",
    fill: "#b09a62"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_157",
    "data-name": "Rectangle 157",
    width: 0.951,
    height: 56.402,
    transform: "translate(60.467 35.768)",
    fill: "#b09a62"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_158",
    "data-name": "Rectangle 158",
    width: 0.951,
    height: 78.082,
    transform: "matrix(0.5, -0.866, 0.866, 0.5, 0.238, 9.746)",
    fill: "#b09a62"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_159",
    "data-name": "Rectangle 159",
    width: 0.951,
    height: 78.082,
    transform: "matrix(0.5, -0.866, 0.866, 0.5, 0.238, 17.73)",
    fill: "#b09a62"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_160",
    "data-name": "Rectangle 160",
    width: 0.951,
    height: 78.082,
    transform: "translate(0.238 25.714) rotate(-60)",
    fill: "#b09a62"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_161",
    "data-name": "Rectangle 161",
    width: 0.952,
    height: 78.082,
    transform: "translate(0.238 33.698) rotate(-60)",
    fill: "#7e6e5a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_162",
    "data-name": "Rectangle 162",
    width: 0.952,
    height: 78.082,
    transform: "translate(0.238 41.682) rotate(-60)",
    fill: "#7e6e5a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_163",
    "data-name": "Rectangle 163",
    width: 0.952,
    height: 78.082,
    transform: "translate(0.238 49.666) rotate(-60)",
    fill: "#b09a62"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_369",
    "data-name": "Group 369",
    transform: "translate(297.402 241.033)",
    opacity: 0.5,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    id: "Group_368",
    "data-name": "Group 368"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_367",
    "data-name": "Group 367",
    clipPath: "url(#clip-path-151)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_366",
    "data-name": "Group 366",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_365",
    "data-name": "Group 365",
    clipPath: "url(#clip-path-152)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_165",
    "data-name": "Rectangle 165",
    width: 79.103,
    height: 84.761,
    transform: "translate(-22.624 33.691) rotate(-60)",
    fill: "url(#linear-gradient-35)"
  }))))))))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    id: "Group_373",
    "data-name": "Group 373",
    transform: "translate(297.397 240.543)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_372",
    "data-name": "Group 372",
    clipPath: "url(#clip-path-153)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_168",
    "data-name": "Rectangle 168",
    width: 68.317,
    height: 23.983,
    transform: "translate(-0.045)",
    fill: "#1dac4c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_411",
    "data-name": "Group 411",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_410",
    "data-name": "Group 410",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_391",
    "data-name": "Group 391",
    transform: "translate(350.227 257.758)",
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  }, _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    id: "Group_390",
    "data-name": "Group 390",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_639",
    "data-name": "Group 639"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_383",
    "data-name": "Group 383"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_382",
    "data-name": "Group 382"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_381",
    "data-name": "Group 381",
    clipPath: "url(#clip-path-155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_380",
    "data-name": "Group 380",
    transform: "translate(-0.002 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_379",
    "data-name": "Group 379",
    clipPath: "url(#clip-path-156)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_171",
    "data-name": "Rectangle 171",
    width: 1.468,
    height: 34.37,
    transform: "translate(-0.484 0.006) rotate(-0.807)",
    fill: "url(#linear-gradient-36)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_388",
    "data-name": "Group 388",
    transform: "translate(0.235 0.969)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_387",
    "data-name": "Group 387"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_386",
    "data-name": "Group 386",
    clipPath: "url(#clip-path-157)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_385",
    "data-name": "Group 385",
    transform: "translate(-0.002 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_384",
    "data-name": "Group 384",
    clipPath: "url(#clip-path-158)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_173",
    "data-name": "Rectangle 173",
    width: 0.579,
    height: 31.555,
    transform: "translate(-0.098 0) rotate(-0.178)",
    fill: "url(#linear-gradient-37)"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_409",
    "data-name": "Group 409",
    transform: "translate(349.831 236.97)",
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  }, _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    id: "Group_408",
    "data-name": "Group 408"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_407",
    "data-name": "Group 407",
    clipPath: "url(#clip-path-159)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_396",
    "data-name": "Group 396"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_395",
    "data-name": "Group 395"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_394",
    "data-name": "Group 394",
    clipPath: "url(#clip-path-159)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_393",
    "data-name": "Group 393",
    transform: "translate(-0.002 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_392",
    "data-name": "Group 392",
    clipPath: "url(#clip-path-161)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_177",
    "data-name": "Rectangle 177",
    width: 2.242,
    height: 20.486,
    transform: "translate(-0.512 0.013) rotate(-1.435)",
    fill: "url(#linear-gradient-38)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_401",
    "data-name": "Group 401",
    transform: "translate(0.383 1.011)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_400",
    "data-name": "Group 400"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_399",
    "data-name": "Group 399",
    clipPath: "url(#clip-path-162)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_398",
    "data-name": "Group 398",
    transform: "translate(0.002 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_397",
    "data-name": "Group 397",
    clipPath: "url(#clip-path-163)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_179",
    "data-name": "Rectangle 179",
    width: 1.346,
    height: 18.918,
    transform: "translate(-0.266 0.004) rotate(-0.807)",
    fill: "url(#linear-gradient-39)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_406",
    "data-name": "Group 406",
    transform: "translate(0.681 2.022)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_405",
    "data-name": "Group 405"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_404",
    "data-name": "Group 404",
    clipPath: "url(#clip-path-164)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_403",
    "data-name": "Group 403",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_402",
    "data-name": "Group 402",
    clipPath: "url(#clip-path-165)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_181",
    "data-name": "Rectangle 181",
    width: 0.581,
    height: 17.362,
    transform: "translate(-0.054 0) rotate(-0.178)",
    fill: "url(#linear-gradient-40)"
  })))))))))))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    id: "Group_413",
    "data-name": "Group 413",
    transform: "translate(348.525 253.991)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_412",
    "data-name": "Group 412",
    clipPath: "url(#clip-path-166)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_185",
    "data-name": "Rectangle 185",
    width: 6.61,
    height: 6.418,
    transform: "translate(-2.632 3.176) rotate(-50.343)",
    fill: "#1dac4c"
  })))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    id: "Group_415",
    "data-name": "Group 415",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_414",
    "data-name": "Group 414",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M1101.185,805.706h0a2.384,2.384,0,0,1-1.191-.353,4.921,4.921,0,0,1-2.266-3.907,1.769,1.769,0,0,1,1.708-2.012,2.386,2.386,0,0,1,1.191.353,4.921,4.921,0,0,1,2.264,3.907,2.226,2.226,0,0,1-.438,1.414,1.6,1.6,0,0,1-1.269.6m-1.748-5c-.384,0-.441.466-.441.744a3.646,3.646,0,0,0,1.632,2.809c.643.374.759.157.838.059a1.021,1.021,0,0,0,.158-.62,3.651,3.651,0,0,0-1.63-2.81,1.136,1.136,0,0,0-.557-.182",
    transform: "translate(-749.837 -546.078)",
    fill: "#ebdef3"
  })))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    id: "Group_417",
    "data-name": "Group 417",
    transform: "translate(412.154 290.471)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_416",
    "data-name": "Group 416",
    clipPath: "url(#clip-path-168)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_187",
    "data-name": "Rectangle 187",
    width: 54.795,
    height: 23.905,
    fill: "url(#linear-gradient-41)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_431",
    "data-name": "Group 431",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_430",
    "data-name": "Group 430",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_426",
    "data-name": "Group 426",
    transform: "translate(412.153 296.714)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    id: "Group_425",
    "data-name": "Group 425"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_424",
    "data-name": "Group 424",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_419",
    "data-name": "Group 419",
    transform: "translate(0.001 0.463)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_418",
    "data-name": "Group 418",
    clipPath: "url(#clip-path-171)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_188",
    "data-name": "Rectangle 188",
    width: 0.009,
    height: 0.22,
    fill: "url(#linear-gradient-42)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_421",
    "data-name": "Group 421",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_420",
    "data-name": "Group 420",
    clipPath: "url(#clip-path-172)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_189",
    "data-name": "Rectangle 189",
    width: 54.795,
    height: 17.661,
    transform: "translate(0)",
    fill: "url(#linear-gradient-43)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_423",
    "data-name": "Group 423",
    transform: "translate(54.787 0.463)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_422",
    "data-name": "Group 422",
    clipPath: "url(#clip-path-173)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_190",
    "data-name": "Rectangle 190",
    width: 0.009,
    height: 0.22,
    fill: "url(#linear-gradient-44)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_429",
    "data-name": "Group 429",
    transform: "translate(413.525 293.184)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    id: "Group_428",
    "data-name": "Group 428"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_427",
    "data-name": "Group 427",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M1413.433,945.526c.261-.049.51-.111.768-.164V925.1h-.768Z",
    transform: "translate(-1379.014 -925.104)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M1424.294,944.714c.256-.072.516-.139.768-.216V925.1h-.768Z",
    transform: "translate(-1386.434 -925.104)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M1435.154,943.586c.265-.1.51-.222.768-.331V925.1h-.768Z",
    transform: "translate(-1393.852 -925.104)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M1402.573,946.022c.256-.027.515-.049.768-.08V925.1h-.768Z",
    transform: "translate(-1371.596 -925.104)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M1456.876,939.7c.262-.21.523-.418.767-.636V925.1h-.767Z",
    transform: "translate(-1408.69 -925.104)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M1467.736,935.984a11.924,11.924,0,0,0,.768-1.359V925.1h-.768Z",
    transform: "translate(-1416.108 -925.104)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M1446.015,941.969c.256-.14.521-.273.768-.419V925.1h-.768Z",
    transform: "translate(-1401.271 -925.104)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M1391.713,946.251c.256-.008.515-.01.768-.023V925.1h-.768Z",
    transform: "translate(-1364.178 -925.104)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M1380.852,946.239c.255.01.511.016.768.022V925.1h-.768Z",
    transform: "translate(-1356.759 -925.104)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M1359.131,945.435c.257.051.508.111.768.158V925.1h-.768Z",
    transform: "translate(-1341.922 -925.104)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M1369.992,945.985c.252.029.513.043.768.068V925.1h-.768Z",
    transform: "translate(-1349.341 -925.104)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M1348.27,944.594q.38.111.768.215V925.1h-.768Z",
    transform: "translate(-1334.503 -925.104)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M1304.829,935.307a12.728,12.728,0,0,0,.768,1.222V925.1h-.768Z",
    transform: "translate(-1304.829 -925.104)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M1315.689,939.366c.242.205.51.4.768.6V925.1h-.768Z",
    transform: "translate(-1312.247 -925.104)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M1337.41,943.4q.379.156.768.3V925.1h-.768Z",
    transform: "translate(-1327.085 -925.104)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M1326.55,941.744c.248.141.512.271.768.406V925.1h-.768Z",
    transform: "translate(-1319.666 -925.104)",
    fill: "#fdd65b"
  }))))))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    id: "Group_433",
    "data-name": "Group 433",
    transform: "translate(412.154 274.626)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_432",
    "data-name": "Group 432",
    clipPath: "url(#clip-path-175)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_194",
    "data-name": "Rectangle 194",
    width: 61.257,
    height: 61.36,
    transform: "matrix(0.705, -0.709, 0.709, 0.705, -15.954, 16.056)",
    fill: "url(#linear-gradient-45)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_440",
    "data-name": "Group 440",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_439",
    "data-name": "Group 439",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_438",
    "data-name": "Group 438",
    transform: "translate(412.153 290.709)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    id: "Group_437",
    "data-name": "Group 437"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_436",
    "data-name": "Group 436",
    clipPath: "url(#clip-path-29)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_435",
    "data-name": "Group 435",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_434",
    "data-name": "Group 434",
    clipPath: "url(#clip-path-178)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_195",
    "data-name": "Rectangle 195",
    width: 54.795,
    height: 16.509,
    transform: "translate(0)",
    fill: "url(#radial-gradient-17)"
  }))))))))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    id: "Group_442",
    "data-name": "Group 442",
    transform: "translate(419.071 278.655)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_441",
    "data-name": "Group 441",
    clipPath: "url(#clip-path-179)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_198",
    "data-name": "Rectangle 198",
    width: 45.792,
    height: 45.869,
    transform: "translate(-11.926 12.002) rotate(-45.182)",
    fill: "url(#linear-gradient-46)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_469",
    "data-name": "Group 469",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_468",
    "data-name": "Group 468",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_447",
    "data-name": "Group 447",
    transform: "translate(419.753 277.972)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    id: "Group_446",
    "data-name": "Group 446"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_445",
    "data-name": "Group 445",
    clipPath: "url(#clip-path-33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_444",
    "data-name": "Group 444",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_443",
    "data-name": "Group 443",
    clipPath: "url(#clip-path-182)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199",
    "data-name": "Rectangle 199",
    width: 40.961,
    height: 12.566,
    transform: "translate(0 0)",
    fill: "url(#radial-gradient-18)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_452",
    "data-name": "Group 452",
    transform: "translate(419.071 278.654)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    id: "Group_451",
    "data-name": "Group 451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_450",
    "data-name": "Group 450",
    clipPath: "url(#clip-path-33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_449",
    "data-name": "Group 449",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_448",
    "data-name": "Group 448",
    clipPath: "url(#clip-path-184)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_201",
    "data-name": "Rectangle 201",
    width: 37.786,
    height: 37.914,
    transform: "matrix(0.705, -0.709, 0.709, 0.705, -6.283, 6.323)",
    fill: "url(#linear-gradient-47)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_457",
    "data-name": "Group 457",
    transform: "translate(412.543 290.199)",
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  }, _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    id: "Group_456",
    "data-name": "Group 456"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_455",
    "data-name": "Group 455",
    clipPath: "url(#clip-path-185)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_454",
    "data-name": "Group 454",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_453",
    "data-name": "Group 453",
    clipPath: "url(#clip-path-186)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_203",
    "data-name": "Rectangle 203",
    width: 41.462,
    height: 33.476,
    transform: "translate(-10.669 32.458) rotate(-74.812)",
    fill: "url(#radial-gradient-19)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_462",
    "data-name": "Group 462",
    transform: "translate(440.755 274.035)",
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  }, _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    id: "Group_461",
    "data-name": "Group 461"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_460",
    "data-name": "Group 460",
    clipPath: "url(#clip-path-39)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_459",
    "data-name": "Group 459",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_458",
    "data-name": "Group 458",
    clipPath: "url(#clip-path-188)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_205",
    "data-name": "Rectangle 205",
    width: 22.274,
    height: 27.976,
    transform: "matrix(0.322, -0.947, 0.947, 0.322, -5.523, 12.739)",
    fill: "url(#radial-gradient-20)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_467",
    "data-name": "Group 467",
    transform: "translate(424.602 282.457)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    id: "Group_466",
    "data-name": "Group 466"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_465",
    "data-name": "Group 465",
    clipPath: "url(#clip-path-41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_464",
    "data-name": "Group 464",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_463",
    "data-name": "Group 463",
    clipPath: "url(#clip-path-190)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_207",
    "data-name": "Rectangle 207",
    width: 32.001,
    height: 18.475,
    transform: "translate(-0.484 -0.241)",
    fill: "url(#linear-gradient-48)"
  }))))))))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    id: "Group_471",
    "data-name": "Group 471",
    transform: "translate(424.603 281.582)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_470",
    "data-name": "Group 470",
    clipPath: "url(#clip-path-191)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_210",
    "data-name": "Rectangle 210",
    width: 36.148,
    height: 34.698,
    transform: "translate(-9.5 7.763) rotate(-40.729)",
    fill: "url(#linear-gradient-49)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_478",
    "data-name": "Group 478",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_477",
    "data-name": "Group 477",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_476",
    "data-name": "Group 476",
    transform: "translate(424.602 281.582)",
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  }, _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    id: "Group_475",
    "data-name": "Group 475"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_474",
    "data-name": "Group 474",
    clipPath: "url(#clip-path-41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_473",
    "data-name": "Group 473",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_472",
    "data-name": "Group 472",
    clipPath: "url(#clip-path-194)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_211",
    "data-name": "Rectangle 211",
    width: 32.001,
    height: 18.475,
    transform: "translate(-0.484 -0.241)",
    fill: "url(#radial-gradient-21)"
  }))))))))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    id: "Group_480",
    "data-name": "Group 480",
    transform: "translate(479.121 312.05)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_479",
    "data-name": "Group 479",
    clipPath: "url(#clip-path-195)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_214",
    "data-name": "Rectangle 214",
    width: 54.796,
    height: 23.905,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-50)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_494",
    "data-name": "Group 494",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_493",
    "data-name": "Group 493",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_489",
    "data-name": "Group 489",
    transform: "translate(479.121 318.294)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    id: "Group_488",
    "data-name": "Group 488"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_487",
    "data-name": "Group 487",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_482",
    "data-name": "Group 482",
    transform: "translate(0 0.463)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_481",
    "data-name": "Group 481",
    clipPath: "url(#clip-path-198)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_215",
    "data-name": "Rectangle 215",
    width: 0.009,
    height: 0.22,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-51)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_484",
    "data-name": "Group 484",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_483",
    "data-name": "Group 483",
    clipPath: "url(#clip-path-199)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_216",
    "data-name": "Rectangle 216",
    width: 54.795,
    height: 17.661,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-52)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_486",
    "data-name": "Group 486",
    transform: "translate(54.786 0.463)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_485",
    "data-name": "Group 485",
    clipPath: "url(#clip-path-200)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_217",
    "data-name": "Rectangle 217",
    width: 0.009,
    height: 0.22,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-53)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_492",
    "data-name": "Group 492",
    transform: "translate(480.49 314.763)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    id: "Group_491",
    "data-name": "Group 491"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_490",
    "data-name": "Group 490",
    clipPath: "url(#clip-path-201)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M1624.739,1013.618c.26-.049.51-.111.768-.164V993.2h-.768Z",
    transform: "translate(-1590.319 -993.196)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M1635.6,1012.8c.256-.072.516-.139.768-.216V993.195h-.768Z",
    transform: "translate(-1597.737 -993.195)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M1646.46,1011.678c.265-.1.51-.222.768-.331V993.2h-.768Z",
    transform: "translate(-1605.156 -993.196)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M1613.879,1014.114c.256-.027.515-.049.768-.08V993.2h-.768Z",
    transform: "translate(-1582.9 -993.196)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M1668.182,1007.788c.262-.21.524-.418.768-.636V993.195h-.768Z",
    transform: "translate(-1619.994 -993.195)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M1679.042,1004.076a11.907,11.907,0,0,0,.768-1.359V993.2h-.768Z",
    transform: "translate(-1627.412 -993.196)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M1657.321,1010.061c.256-.14.521-.274.768-.419V993.2h-.768Z",
    transform: "translate(-1612.575 -993.196)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M1603.019,1014.342c.256-.008.514-.01.768-.023V993.195h-.768Z",
    transform: "translate(-1575.482 -993.195)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    d: "M1592.158,1014.33c.255.01.512.016.768.022V993.195h-.768Z",
    transform: "translate(-1568.063 -993.195)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M1570.438,1013.527c.257.051.507.111.768.157V993.195h-.768Z",
    transform: "translate(-1553.227 -993.195)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M1581.3,1014.076c.252.029.514.043.768.068V993.2h-.768Z",
    transform: "translate(-1560.645 -993.196)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M1559.576,1012.686q.38.111.768.216V993.2h-.768Z",
    transform: "translate(-1545.807 -993.196)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M1516.135,1003.4a12.645,12.645,0,0,0,.768,1.222V993.2h-.768Z",
    transform: "translate(-1516.133 -993.196)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M1526.995,1007.458c.243.205.51.4.768.6V993.2h-.768Z",
    transform: "translate(-1523.551 -993.196)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M1548.716,1011.5q.38.156.768.3V993.2h-.768Z",
    transform: "translate(-1538.388 -993.196)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M1537.856,1009.836c.247.141.512.271.768.407V993.2h-.768Z",
    transform: "translate(-1530.971 -993.196)",
    fill: "#fdd65b"
  }))))))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    id: "Group_496",
    "data-name": "Group 496",
    transform: "translate(479.121 296.206)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_495",
    "data-name": "Group 495",
    clipPath: "url(#clip-path-202)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_221",
    "data-name": "Rectangle 221",
    width: 61.258,
    height: 61.361,
    transform: "translate(-15.954 16.056) rotate(-45.182)",
    fill: "url(#linear-gradient-54)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_503",
    "data-name": "Group 503",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_502",
    "data-name": "Group 502",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_501",
    "data-name": "Group 501",
    transform: "translate(479.121 312.288)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    id: "Group_500",
    "data-name": "Group 500"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_499",
    "data-name": "Group 499",
    clipPath: "url(#clip-path-29)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_498",
    "data-name": "Group 498",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_497",
    "data-name": "Group 497",
    clipPath: "url(#clip-path-205)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_222",
    "data-name": "Rectangle 222",
    width: 54.795,
    height: 16.509,
    fill: "url(#radial-gradient-22)"
  }))))))))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    id: "Group_505",
    "data-name": "Group 505",
    transform: "translate(486.038 300.234)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_504",
    "data-name": "Group 504",
    clipPath: "url(#clip-path-206)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_225",
    "data-name": "Rectangle 225",
    width: 45.792,
    height: 45.869,
    transform: "matrix(0.705, -0.709, 0.709, 0.705, -11.926, 12.002)",
    fill: "url(#linear-gradient-55)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_532",
    "data-name": "Group 532",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_531",
    "data-name": "Group 531",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_510",
    "data-name": "Group 510",
    transform: "translate(486.721 299.551)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    id: "Group_509",
    "data-name": "Group 509"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_508",
    "data-name": "Group 508",
    clipPath: "url(#clip-path-33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_507",
    "data-name": "Group 507",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_506",
    "data-name": "Group 506",
    clipPath: "url(#clip-path-209)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_226",
    "data-name": "Rectangle 226",
    width: 40.961,
    height: 12.566,
    transform: "translate(0 0)",
    fill: "url(#radial-gradient-23)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_515",
    "data-name": "Group 515",
    transform: "translate(486.036 300.234)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    id: "Group_514",
    "data-name": "Group 514"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_513",
    "data-name": "Group 513",
    clipPath: "url(#clip-path-33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_512",
    "data-name": "Group 512",
    transform: "translate(0.002 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_511",
    "data-name": "Group 511",
    clipPath: "url(#clip-path-211)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_228",
    "data-name": "Rectangle 228",
    width: 37.786,
    height: 37.913,
    transform: "translate(-6.283 6.323) rotate(-45.182)",
    fill: "url(#linear-gradient-56)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_520",
    "data-name": "Group 520",
    transform: "translate(479.508 311.779)",
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  }, _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    id: "Group_519",
    "data-name": "Group 519"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_518",
    "data-name": "Group 518",
    clipPath: "url(#clip-path-37)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_517",
    "data-name": "Group 517",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_516",
    "data-name": "Group 516",
    clipPath: "url(#clip-path-213)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_230",
    "data-name": "Rectangle 230",
    width: 41.462,
    height: 33.476,
    transform: "translate(-10.669 32.458) rotate(-74.812)",
    fill: "url(#radial-gradient-24)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_525",
    "data-name": "Group 525",
    transform: "translate(507.723 295.614)",
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  }, _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    id: "Group_524",
    "data-name": "Group 524"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_523",
    "data-name": "Group 523",
    clipPath: "url(#clip-path-39)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_522",
    "data-name": "Group 522",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_521",
    "data-name": "Group 521",
    clipPath: "url(#clip-path-215)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_232",
    "data-name": "Rectangle 232",
    width: 22.274,
    height: 27.976,
    transform: "matrix(0.322, -0.947, 0.947, 0.322, -5.524, 12.739)",
    fill: "url(#radial-gradient-25)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_530",
    "data-name": "Group 530",
    transform: "translate(491.57 304.036)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    id: "Group_529",
    "data-name": "Group 529"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_528",
    "data-name": "Group 528",
    clipPath: "url(#clip-path-41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_527",
    "data-name": "Group 527",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_526",
    "data-name": "Group 526",
    clipPath: "url(#clip-path-217)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_234",
    "data-name": "Rectangle 234",
    width: 32.001,
    height: 18.475,
    transform: "translate(-0.484 -0.241)",
    fill: "url(#linear-gradient-57)"
  }))))))))), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    id: "Group_534",
    "data-name": "Group 534",
    transform: "translate(491.57 303.162)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_533",
    "data-name": "Group 533",
    clipPath: "url(#clip-path-218)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_237",
    "data-name": "Rectangle 237",
    width: 36.148,
    height: 34.698,
    transform: "matrix(0.758, -0.652, 0.652, 0.758, -9.5, 7.763)",
    fill: "url(#linear-gradient-58)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_541",
    "data-name": "Group 541",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_540",
    "data-name": "Group 540",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_539",
    "data-name": "Group 539",
    transform: "translate(491.57 303.161)",
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  }, _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    id: "Group_538",
    "data-name": "Group 538"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_537",
    "data-name": "Group 537",
    clipPath: "url(#clip-path-41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_536",
    "data-name": "Group 536",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_535",
    "data-name": "Group 535",
    clipPath: "url(#clip-path-221)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_238",
    "data-name": "Rectangle 238",
    width: 32.001,
    height: 18.475,
    transform: "translate(-0.484 -0.241)",
    fill: "url(#radial-gradient-26)"
  }))))))))), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    id: "Group_543",
    "data-name": "Group 543",
    transform: "translate(542.649 289.875)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_542",
    "data-name": "Group 542",
    clipPath: "url(#clip-path-222)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_241",
    "data-name": "Rectangle 241",
    width: 54.795,
    height: 23.905,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-59)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_557",
    "data-name": "Group 557",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_556",
    "data-name": "Group 556",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_552",
    "data-name": "Group 552",
    transform: "translate(542.648 296.119)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    id: "Group_551",
    "data-name": "Group 551"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_550",
    "data-name": "Group 550",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_545",
    "data-name": "Group 545",
    transform: "translate(0.001 0.463)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_544",
    "data-name": "Group 544",
    clipPath: "url(#clip-path-225)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_242",
    "data-name": "Rectangle 242",
    width: 0.01,
    height: 0.22,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-60)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_547",
    "data-name": "Group 547",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_546",
    "data-name": "Group 546",
    clipPath: "url(#clip-path-226)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_243",
    "data-name": "Rectangle 243",
    width: 54.795,
    height: 17.661,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-61)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_549",
    "data-name": "Group 549",
    transform: "translate(54.787 0.463)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_548",
    "data-name": "Group 548",
    clipPath: "url(#clip-path-227)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_244",
    "data-name": "Rectangle 244",
    width: 0.009,
    height: 0.22,
    fill: "url(#linear-gradient-62)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_555",
    "data-name": "Group 555",
    transform: "translate(544.02 292.588)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    id: "Group_554",
    "data-name": "Group 554"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_553",
    "data-name": "Group 553",
    clipPath: "url(#clip-path-123)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M1825.193,943.647c.261-.049.51-.11.768-.164V923.225h-.768Z",
    transform: "translate(-1790.774 -923.225)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M1836.054,942.835c.256-.072.516-.14.768-.216V923.225h-.768Z",
    transform: "translate(-1798.194 -923.225)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M1846.914,941.706c.265-.1.51-.222.768-.331V923.224h-.768Z",
    transform: "translate(-1805.612 -923.224)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M1814.333,944.143c.256-.027.515-.049.768-.08V923.225h-.768Z",
    transform: "translate(-1783.356 -923.225)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M1868.636,937.818c.262-.21.524-.418.768-.636V923.225h-.768Z",
    transform: "translate(-1820.449 -923.225)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M1879.5,934.1a12,12,0,0,0,.768-1.359v-9.521h-.768Z",
    transform: "translate(-1827.868 -923.224)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M1857.775,940.09c.256-.14.521-.274.768-.419V923.225h-.768Z",
    transform: "translate(-1813.031 -923.225)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M1803.473,944.372c.256-.008.514-.01.768-.023V923.225h-.768Z",
    transform: "translate(-1775.938 -923.225)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M1792.612,944.36c.255.01.511.017.768.022V923.225h-.768Z",
    transform: "translate(-1768.519 -923.225)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M1770.891,943.557c.257.051.507.111.768.158V923.225h-.768Z",
    transform: "translate(-1753.682 -923.225)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M1781.752,944.106c.252.029.513.043.768.068V923.225h-.768Z",
    transform: "translate(-1761.101 -923.225)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M1760.03,942.715q.381.111.768.215V923.225h-.768Z",
    transform: "translate(-1746.263 -923.225)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M1716.589,933.428a12.737,12.737,0,0,0,.768,1.222V923.225h-.768Z",
    transform: "translate(-1716.589 -923.225)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M1727.449,937.487c.242.205.51.4.768.6v-14.86h-.768Z",
    transform: "translate(-1724.008 -923.225)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M1749.17,941.525q.38.156.768.3v-18.6h-.768Z",
    transform: "translate(-1738.844 -923.225)",
    fill: "#fdd65b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M1738.31,939.865c.247.141.512.271.768.406V923.225h-.768Z",
    transform: "translate(-1731.427 -923.225)",
    fill: "#fdd65b"
  }))))))), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    id: "Group_559",
    "data-name": "Group 559",
    transform: "translate(542.649 274.031)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_558",
    "data-name": "Group 558",
    clipPath: "url(#clip-path-229)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_248",
    "data-name": "Rectangle 248",
    width: 61.258,
    height: 61.36,
    transform: "translate(-15.954 16.056) rotate(-45.182)",
    fill: "url(#linear-gradient-63)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_566",
    "data-name": "Group 566",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_565",
    "data-name": "Group 565",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_564",
    "data-name": "Group 564",
    transform: "translate(542.648 290.113)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    id: "Group_563",
    "data-name": "Group 563"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_562",
    "data-name": "Group 562",
    clipPath: "url(#clip-path-29)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_561",
    "data-name": "Group 561",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_560",
    "data-name": "Group 560",
    clipPath: "url(#clip-path-232)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_249",
    "data-name": "Rectangle 249",
    width: 54.795,
    height: 16.509,
    transform: "translate(0 0)",
    fill: "url(#radial-gradient-27)"
  }))))))))), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    id: "Group_568",
    "data-name": "Group 568",
    transform: "translate(549.566 278.059)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_567",
    "data-name": "Group 567",
    clipPath: "url(#clip-path-233)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_252",
    "data-name": "Rectangle 252",
    width: 45.792,
    height: 45.869,
    transform: "translate(-11.926 12.002) rotate(-45.182)",
    fill: "url(#linear-gradient-64)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_595",
    "data-name": "Group 595",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_594",
    "data-name": "Group 594",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_573",
    "data-name": "Group 573",
    transform: "translate(550.247 277.376)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    id: "Group_572",
    "data-name": "Group 572"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_571",
    "data-name": "Group 571",
    clipPath: "url(#clip-path-33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_570",
    "data-name": "Group 570",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_569",
    "data-name": "Group 569",
    clipPath: "url(#clip-path-236)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_253",
    "data-name": "Rectangle 253",
    width: 40.961,
    height: 12.567,
    transform: "translate(0 0)",
    fill: "url(#radial-gradient-28)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_578",
    "data-name": "Group 578",
    transform: "translate(549.566 278.059)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    id: "Group_577",
    "data-name": "Group 577"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_576",
    "data-name": "Group 576",
    clipPath: "url(#clip-path-33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_575",
    "data-name": "Group 575",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_574",
    "data-name": "Group 574",
    clipPath: "url(#clip-path-238)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_255",
    "data-name": "Rectangle 255",
    width: 37.786,
    height: 37.913,
    transform: "translate(-6.283 6.323) rotate(-45.182)",
    fill: "url(#linear-gradient-65)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_583",
    "data-name": "Group 583",
    transform: "translate(543.038 289.603)",
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  }, _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    id: "Group_582",
    "data-name": "Group 582"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_581",
    "data-name": "Group 581",
    clipPath: "url(#clip-path-185)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_580",
    "data-name": "Group 580",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_579",
    "data-name": "Group 579",
    clipPath: "url(#clip-path-240)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_257",
    "data-name": "Rectangle 257",
    width: 41.462,
    height: 33.476,
    transform: "translate(-10.669 32.458) rotate(-74.812)",
    fill: "url(#radial-gradient-29)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_588",
    "data-name": "Group 588",
    transform: "translate(571.25 273.439)",
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  }, _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    id: "Group_587",
    "data-name": "Group 587"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_586",
    "data-name": "Group 586",
    clipPath: "url(#clip-path-39)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_585",
    "data-name": "Group 585",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_584",
    "data-name": "Group 584",
    clipPath: "url(#clip-path-242)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_259",
    "data-name": "Rectangle 259",
    width: 22.274,
    height: 27.976,
    transform: "matrix(0.322, -0.947, 0.947, 0.322, -5.523, 12.739)",
    fill: "url(#radial-gradient-30)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_593",
    "data-name": "Group 593",
    transform: "translate(555.096 281.861)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g113 || (_g113 = /*#__PURE__*/React.createElement("g", {
    id: "Group_592",
    "data-name": "Group 592"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_591",
    "data-name": "Group 591",
    clipPath: "url(#clip-path-41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_590",
    "data-name": "Group 590",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_589",
    "data-name": "Group 589",
    clipPath: "url(#clip-path-244)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_261",
    "data-name": "Rectangle 261",
    width: 32.001,
    height: 18.475,
    transform: "translate(-0.484 -0.241)",
    fill: "url(#linear-gradient-66)"
  }))))))))), _g114 || (_g114 = /*#__PURE__*/React.createElement("g", {
    id: "Group_597",
    "data-name": "Group 597",
    transform: "translate(555.097 280.986)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_596",
    "data-name": "Group 596",
    clipPath: "url(#clip-path-245)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_264",
    "data-name": "Rectangle 264",
    width: 36.148,
    height: 34.698,
    transform: "translate(-9.5 7.763) rotate(-40.729)",
    fill: "url(#linear-gradient-67)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_59646",
    "data-name": "Group 59646",
    transform: "translate(-626.802 4170)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_752",
    "data-name": "Mask Group 752",
    transform: "translate(1109 -1538)",
    clipPath: "url(#clip-path-246)"
  }, _g115 || (_g115 = /*#__PURE__*/React.createElement("g", {
    id: "Group_675",
    "data-name": "Group 675"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_674",
    "data-name": "Group 674",
    clipPath: "url(#clip-path-246)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_294",
    "data-name": "Rectangle 294",
    width: 116.303,
    height: 92.808,
    transform: "translate(43.467 148.458)",
    xlinkHref: "data:image/png;base64,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"
  })))), _g116 || (_g116 = /*#__PURE__*/React.createElement("g", {
    id: "Group_677",
    "data-name": "Group 677",
    transform: "translate(172.042 118.803)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_676",
    "data-name": "Group 676",
    clipPath: "url(#clip-path-248)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16026",
    "data-name": "Path 16026",
    d: "M0,0H11.554V11.554H0Z",
    transform: "translate(0 0)",
    fill: "#fada70"
  })))), _g117 || (_g117 = /*#__PURE__*/React.createElement("g", {
    id: "Group_679",
    "data-name": "Group 679",
    transform: "translate(35.757 140.485)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_678",
    "data-name": "Group 678",
    clipPath: "url(#clip-path-249)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_299",
    "data-name": "Rectangle 299",
    width: 6.142,
    height: 6.142,
    transform: "translate(0 0)",
    fill: "#cf4343"
  })))), _g118 || (_g118 = /*#__PURE__*/React.createElement("g", {
    id: "Group_683",
    "data-name": "Group 683",
    transform: "translate(27.962 74.991)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_682",
    "data-name": "Group 682",
    clipPath: "url(#clip-path-250)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_301",
    "data-name": "Rectangle 301",
    width: 3.275,
    height: 3.276,
    transform: "translate(0)",
    fill: "url(#radial-gradient-31)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_716",
    "data-name": "Group 716"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_715",
    "data-name": "Group 715",
    clipPath: "url(#clip-path-246)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_708",
    "data-name": "Group 708",
    transform: "translate(168.167 27.791)",
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  }, _g119 || (_g119 = /*#__PURE__*/React.createElement("g", {
    id: "Group_707",
    "data-name": "Group 707"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_706",
    "data-name": "Group 706",
    clipPath: "url(#clip-path-252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_705",
    "data-name": "Group 705",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_704",
    "data-name": "Group 704",
    clipPath: "url(#clip-path-253)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_310",
    "data-name": "Rectangle 310",
    width: 26.729,
    height: 26.729,
    transform: "translate(0 0)",
    fill: "url(#radial-gradient-32)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_711",
    "data-name": "Group 711",
    transform: "translate(16.898 68.41)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g120 || (_g120 = /*#__PURE__*/React.createElement("g", {
    id: "Group_710",
    "data-name": "Group 710"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_709",
    "data-name": "Group 709",
    clipPath: "url(#clip-path-254)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1085",
    "data-name": "Path 1085",
    d: "M159.737,126.356c12.33,6.955,24.587,14.059,36.431,21.843,2.948,1.965,5.859,3.991,8.676,6.155a46.925,46.925,0,0,1,4.068,3.466,10.323,10.323,0,0,1,1.747,2.112,2.456,2.456,0,0,1,.271.717,1.106,1.106,0,0,1-.169.888,1.928,1.928,0,0,1-1.459.573,20.4,20.4,0,0,1-5.325-.887c-1.719-.468-3.413-1-5.094-1.572-3.361-1.142-6.675-2.4-9.969-3.708-13.161-5.264-26.043-11.171-38.839-17.238q-19.185-9.13-38.055-18.9-18.838-9.821-37.379-20.2C62.3,92.672,50.041,85.562,38.057,78,32.082,74.2,26.132,70.337,20.5,66a47.587,47.587,0,0,1-4.058-3.48,10.523,10.523,0,0,1-1.741-2.111,2.384,2.384,0,0,1-.283-.7,1.064,1.064,0,0,1,.134-.874,1.813,1.813,0,0,1,1.437-.6,19.753,19.753,0,0,1,5.317.892c1.716.472,3.408,1.011,5.083,1.6,6.692,2.354,13.22,5.108,19.71,7.937s12.917,5.8,19.315,8.833c-6.438-2.943-12.907-5.819-19.426-8.571s-13.087-5.405-19.783-7.66c-1.674-.559-3.355-1.1-5.056-1.554a19.422,19.422,0,0,0-5.117-.848,1.319,1.319,0,0,0-.952.323c-.148.164-.018.572.18.914a10,10,0,0,0,1.64,1.958,46.975,46.975,0,0,0,4.015,3.409c5.607,4.283,11.569,8.113,17.55,11.881,12,7.5,24.277,14.543,36.644,21.42s24.867,13.521,37.441,20.014q18.823,9.814,37.937,19.055c12.757,6.119,25.6,12.081,38.709,17.394,3.28,1.318,6.579,2.589,9.916,3.739,1.668.574,3.348,1.114,5.043,1.582a20,20,0,0,0,5.108.888c.391-.021.84-.109.96-.3.136-.155.035-.538-.15-.886a9.7,9.7,0,0,0-1.624-1.968,46.055,46.055,0,0,0-3.994-3.434c-2.784-2.165-5.687-4.187-8.608-6.178-11.717-7.927-23.88-15.195-36.115-22.313",
    transform: "translate(-14.384 -58.232)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_714",
    "data-name": "Group 714",
    transform: "translate(16.898 68.41)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g121 || (_g121 = /*#__PURE__*/React.createElement("g", {
    id: "Group_713",
    "data-name": "Group 713"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_712",
    "data-name": "Group 712",
    clipPath: "url(#clip-path-254)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1086",
    "data-name": "Path 1086",
    d: "M65.607,126.356c-12.33,6.955-24.587,14.059-36.431,21.843-2.949,1.965-5.859,3.991-8.676,6.155a46.751,46.751,0,0,0-4.068,3.466,10.323,10.323,0,0,0-1.747,2.112,2.455,2.455,0,0,0-.271.717,1.106,1.106,0,0,0,.168.888,1.93,1.93,0,0,0,1.46.573,20.4,20.4,0,0,0,5.325-.887c1.719-.468,3.413-1,5.094-1.572,3.36-1.142,6.675-2.4,9.969-3.708,13.161-5.264,26.043-11.171,38.839-17.238q19.185-9.13,38.055-18.9,18.838-9.821,37.379-20.2c12.346-6.941,24.6-14.05,36.584-21.612,5.975-3.8,11.925-7.663,17.552-12a47.588,47.588,0,0,0,4.058-3.48,10.522,10.522,0,0,0,1.741-2.111,2.416,2.416,0,0,0,.283-.7,1.068,1.068,0,0,0-.134-.874,1.813,1.813,0,0,0-1.437-.6,19.77,19.77,0,0,0-5.318.892c-1.715.472-3.407,1.011-5.082,1.6-6.692,2.354-13.221,5.108-19.71,7.937s-12.917,5.8-19.315,8.833c6.438-2.943,12.906-5.819,19.426-8.571s13.087-5.405,19.783-7.66c1.674-.559,3.355-1.1,5.055-1.554a19.439,19.439,0,0,1,5.119-.848,1.321,1.321,0,0,1,.952.323c.148.164.018.572-.18.914a9.96,9.96,0,0,1-1.641,1.958,46.77,46.77,0,0,1-4.014,3.409c-5.608,4.283-11.569,8.113-17.55,11.881-12,7.5-24.277,14.543-36.645,21.42s-24.867,13.521-37.44,20.014q-18.823,9.814-37.937,19.055c-12.757,6.119-25.6,12.081-38.709,17.394-3.28,1.318-6.579,2.589-9.916,3.739-1.668.574-3.348,1.114-5.043,1.582a20,20,0,0,1-5.108.888c-.391-.021-.84-.109-.96-.3-.136-.155-.035-.538.15-.886a9.706,9.706,0,0,1,1.624-1.968,45.883,45.883,0,0,1,3.994-3.434c2.784-2.165,5.687-4.187,8.608-6.178,11.717-7.927,23.88-15.195,36.115-22.313",
    transform: "translate(-14.384 -58.232)",
    fill: "#fff"
  }))))))), _g122 || (_g122 = /*#__PURE__*/React.createElement("g", {
    id: "Group_722",
    "data-name": "Group 722",
    transform: "translate(160.007 35.276)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_721",
    "data-name": "Group 721",
    clipPath: "url(#clip-path-257)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_317",
    "data-name": "Rectangle 317",
    width: 8.599,
    height: 8.597,
    fill: "#1dac4c"
  })))), _g123 || (_g123 = /*#__PURE__*/React.createElement("g", {
    id: "Group_724",
    "data-name": "Group 724",
    transform: "translate(148.107 52.936)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_723",
    "data-name": "Group 723",
    opacity: 0.72,
    clipPath: "url(#clip-path-258)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_318",
    "data-name": "Rectangle 318",
    width: 33.425,
    height: 12.247,
    transform: "translate(-3.664 32.245) rotate(-83.517)",
    fill: "#fada70"
  })))), _g124 || (_g124 = /*#__PURE__*/React.createElement("g", {
    id: "Group_726",
    "data-name": "Group 726",
    transform: "translate(146.345 49.179)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_725",
    "data-name": "Group 725",
    clipPath: "url(#clip-path-259)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_319",
    "data-name": "Rectangle 319",
    width: 16.573,
    height: 16.573,
    transform: "translate(-4.694 10.416) rotate(-65.739)",
    fill: "#fada70"
  })))), _g125 || (_g125 = /*#__PURE__*/React.createElement("g", {
    id: "Group_728",
    "data-name": "Group 728",
    transform: "translate(45.314 52.936)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_727",
    "data-name": "Group 727",
    opacity: 0.72,
    clipPath: "url(#clip-path-260)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_320",
    "data-name": "Rectangle 320",
    width: 33.425,
    height: 12.247,
    transform: "translate(-3.664 32.245) rotate(-83.517)",
    fill: "#fada70"
  })))), _g126 || (_g126 = /*#__PURE__*/React.createElement("g", {
    id: "Group_730",
    "data-name": "Group 730",
    transform: "translate(43.551 49.179)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_729",
    "data-name": "Group 729",
    clipPath: "url(#clip-path-261)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_321",
    "data-name": "Rectangle 321",
    width: 16.574,
    height: 16.574,
    transform: "translate(-4.694 10.416) rotate(-65.739)",
    fill: "#fada70"
  })))), _g127 || (_g127 = /*#__PURE__*/React.createElement("g", {
    id: "Group_732",
    "data-name": "Group 732",
    transform: "translate(151.24 84.813)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_731",
    "data-name": "Group 731",
    clipPath: "url(#clip-path-262)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_322",
    "data-name": "Rectangle 322",
    width: 30.66,
    height: 18.18,
    transform: "translate(-4.795 27.97) rotate(-80.272)",
    fill: "#fada70"
  })))), _g128 || (_g128 = /*#__PURE__*/React.createElement("g", {
    id: "Group_734",
    "data-name": "Group 734",
    transform: "translate(151.24 95.777)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_733",
    "data-name": "Group 733",
    clipPath: "url(#clip-path-263)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_324",
    "data-name": "Rectangle 324",
    width: 20.799,
    height: 17.798,
    transform: "translate(-4.609 16.543) rotate(-74.434)",
    fill: "#fada70"
  })))), _g129 || (_g129 = /*#__PURE__*/React.createElement("g", {
    id: "Group_736",
    "data-name": "Group 736",
    transform: "translate(37.457 84.813)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_735",
    "data-name": "Group 735",
    clipPath: "url(#clip-path-264)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_326",
    "data-name": "Rectangle 326",
    width: 30.66,
    height: 18.182,
    transform: "translate(-4.795 27.97) rotate(-80.272)",
    fill: "#fada70"
  })))), _g130 || (_g130 = /*#__PURE__*/React.createElement("g", {
    id: "Group_738",
    "data-name": "Group 738",
    transform: "translate(37.457 95.777)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_737",
    "data-name": "Group 737",
    clipPath: "url(#clip-path-265)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_328",
    "data-name": "Rectangle 328",
    width: 20.799,
    height: 17.8,
    transform: "translate(-4.609 16.543) rotate(-74.434)",
    fill: "#fada70"
  })))), _g131 || (_g131 = /*#__PURE__*/React.createElement("g", {
    id: "Group_740",
    "data-name": "Group 740",
    transform: "translate(44.212 51.684)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_739",
    "data-name": "Group 739",
    clipPath: "url(#clip-path-266)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16027",
    "data-name": "Path 16027",
    d: "M0,0H122.343V137.266H0Z",
    transform: "matrix(0.3, -0.954, 0.954, 0.3, -26.341, 83.861)",
    fill: "#1dab4b"
  })))), _g132 || (_g132 = /*#__PURE__*/React.createElement("g", {
    id: "Group_742",
    "data-name": "Group 742",
    transform: "translate(54.836 60.124)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_741",
    "data-name": "Group 741",
    clipPath: "url(#clip-path-267)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16185",
    "data-name": "Path 16185",
    d: "M0,0H93.689V71.229H0Z",
    transform: "translate(0 0)",
    fill: "#cf4343"
  })))), _g133 || (_g133 = /*#__PURE__*/React.createElement("g", {
    id: "Group_744",
    "data-name": "Group 744",
    transform: "translate(57.287 62.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_743",
    "data-name": "Group 743",
    clipPath: "url(#clip-path-268)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_332",
    "data-name": "Rectangle 332",
    width: 103.377,
    height: 110.288,
    transform: "matrix(0.54, -0.841, 0.841, 0.54, -29.935, 46.62)",
    fill: "#fada70"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_751",
    "data-name": "Group 751"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_750",
    "data-name": "Group 750",
    clipPath: "url(#clip-path-246)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1098",
    "data-name": "Path 1098",
    d: "M117.891,88.118H66.2a6.461,6.461,0,0,1,0-12.923h51.69a6.461,6.461,0,1,1,0,12.923",
    transform: "translate(10.441 13.143)",
    fill: "#070813"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1099",
    "data-name": "Path 1099",
    d: "M97.19,92.142H80.81a1.4,1.4,0,1,1,0-2.808H97.19a1.4,1.4,0,1,1,0,2.808",
    transform: "translate(13.879 15.614)",
    fill: "#1dab4b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_749",
    "data-name": "Group 749",
    transform: "translate(89.368 62.166)",
    opacity: 0.36,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g134 || (_g134 = /*#__PURE__*/React.createElement("g", {
    id: "Group_748",
    "data-name": "Group 748"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_747",
    "data-name": "Group 747",
    clipPath: "url(#clip-path-270)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_746",
    "data-name": "Group 746",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_745",
    "data-name": "Group 745",
    clipPath: "url(#clip-path-271)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_333",
    "data-name": "Rectangle 333",
    width: 61.458,
    height: 65.739,
    transform: "translate(-9.955 49.22) rotate(-78.566)",
    fill: "url(#linear-gradient-68)"
  }))))))))))))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M86.289,11.31l-16.6-10.25L67.976,0,66.258,1.061l-61.1,37.75L0,41.993l5.15,3.184,6.173,3.815,1.718,1.061,1.718-1.061L40.252,33.244l2.179,1.345L55.8,40.6s5.085,1.517,7.607,1.515A39.413,39.413,0,0,0,83.8,36.183c7.736-4.78,9.361-10.027,9.361-13.587,0-4.4-2.571-8.622-6.878-11.285M73.921,25.826c-4.1,2.534-7.932,3.818-11.39,3.818A11.282,11.282,0,0,1,56.5,28l-3.883-2.4L68.656,15.7,74.5,19.307c3.079,1.9,3.335,2.992,3.335,3s-.282,1.273-3.914,3.514",
    transform: "translate(-828.204 2950.588) rotate(-3)",
    fill: "#1dab4b"
  })), _g135 || (_g135 = /*#__PURE__*/React.createElement("g", {
    id: "Group_60810",
    "data-name": "Group 60810",
    transform: "translate(-247.739 -552.067) rotate(3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M77.451,13.551,55.622.947,53.982,0l-1.64.948L47.093,3.979,42.175,6.82,47.1,9.66l3,1.732L0,42.325l12.464,7.193L62.558,18.584l6.368,3.679,1.64.947,1.64-.948,5.248-3.032,4.918-2.841Z",
    transform: "translate(-461.348 3483.041) rotate(-3)",
    fill: "#1dab4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17368",
    "data-name": "Path 17368",
    d: "M-404.365,3493.549l-7.994-5.261,12.253-7.576,29.42,18.239-12.384,8Z",
    transform: "matrix(0.998, -0.07, 0.07, 0.998, -306.739, 17.438)",
    fill: "#1dab4b"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M73.006,3.941A30.561,30.561,0,0,0,57.512,0C42.869,0,27.7,8.757,21.993,12.055l-.582.336C10.293,18.793.005,25.9,0,34.44c0,4.307,2.636,8.016,7.848,11.024A30.678,30.678,0,0,0,23.4,49.411c14.577,0,29.019-8.345,35.187-11.909l.356-.206.38-.22c6.975-4.025,21.489-12.4,21.491-22.149,0-4.3-2.627-7.994-7.808-10.988M61.669,20.005a116.82,116.82,0,0,1-11.617,7.287l-.832.48-.261.149c-7.329,4.232-17.369,10.03-25.5,10.03a12.735,12.735,0,0,1-6.541-1.626c-1.592-.92-1.942-1.575-1.942-1.749,0-.141.1-1.462,3.68-4.426a98.7,98.7,0,0,1,13.08-8.571l.651-.376c6.67-3.855,16.75-9.683,25.166-9.683a12.459,12.459,0,0,1,6.4,1.557c1.675.967,2.122,1.705,2.122,1.989,0,.164-.124,1.694-4.4,4.939",
    transform: "translate(-746.584 2996.713) rotate(-3)",
    fill: "#1dab4b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRot);
export default __webpack_public_path__ + "static/media/Rot.99a5a9bca3d034133628a1527aa614fb.svg";
export { ForwardRef as ReactComponent };